import { useState, useEffect } from "react";

// ─── CONSTANTS ────────────────────────────────────────────────
const PARISHES = [
  { id: "Canillo", name: "Canillo", price: 7.95 },
  { id: "Encamp", name: "Encamp", price: 9.47 },
  { id: "Ordino", name: "Ordino", price: 8.81 },
  { id: "La Massana", name: "La Massana", price: 9.56 },
  { id: "Andorra la Vella", name: "Andorra la Vella", price: 10.7 },
  { id: "Sant Julià de Lòria", name: "Sant Julià de Lòria", price: 9.22 },
  { id: "Escaldes-Engordany", name: "Escaldes-Engordany", price: 10.7 },
];
const PARISH_BY_ID = Object.fromEntries(PARISHES.map((p) => [p.id, p]));

// ─── PALETA FERCAMP ────────────────────────────────────────────
const C = {
  red: "#97312b",
  redDark: "#7a2520",
  redLight: "#c94235",
  cream: "#f9f6f1",
  sand: "#f0ebe2",
  border: "#e5ddd0",
  text: "#1c1410",
  muted: "#8a7060",
  hint: "#b8a898",
  amber: "#d4820a",
  amberBg: "#fef3dc",
};

const EMAIL = "fercamp@andorra.ad";
const WHATSAPP = "376374133";
const WA_URL = `https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Hola! Us contacto des del simulador de lloguers d'Andorra.")}`;

// ─── BANNER CONFIG ────────────────────────────────────────────
// Canvia a false per desactivar el banner de captació de leads
const BANNER_ACTIVE = true;

// ─── SIMULACIÓ LIMITADA ───────────────────────────────────────
// Nombre màxim de simulacions per dispositiu (localStorage)
const MAX_SIMULATIONS = 5;
// true → bloqueja la simulació fins que s'omple el banner
// false → mostra el banner però calcula igualment en tancar-lo
const LOCK_SIMULATION = true;
const SIM_COUNT_KEY = "fercamp_sim_count";

// ─── SISTEMA DE CODIS (Firebase) ─────────────────────────────
// ID del document a Firestore = el codi en majúscules (ex: "ABC12345")
const CODE_LS_KEY = "fercamp_code"; // codi activat
const CODE_COUNT_KEY = "fercamp_code_count"; // simulacions fetes amb el codi
const CODE_MAX_KEY = "fercamp_code_max"; // màxim permès pel codi

// ─── AIRTABLE CONFIG ──────────────────────────────────────────
// Regenera el token a airtable.com → Account → Personal Access Tokens
const AT_TOKEN =
  "pat1AY9TjKOOgHF0G.18a14a45a6f4bbf528cbb21581758fb5df0dbc03154aab6d5b5cf567d5eead6b";
const AT_BASE = "appzZfER7DtkwZTrb";
const AT_TABLE = "LLOGUERS ANDORRA";
const AT_URL = `https://api.airtable.com/v0/${AT_BASE}/${encodeURIComponent(AT_TABLE)}`;
const LS_KEY = "fercamp_lead_done"; // localStorage key

async function submitToAirtable(data) {
  try {
    await fetch(AT_URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${AT_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fields: {
          Nom: data.nom,
          Correu: data.correu,
          Telèfon: data.telefon,
          "Nº pisos afectats": parseInt(data.pisos) || 1,
          Comentaris: data.comentaris || "",
          Propietari: data.propietari === true,
          Data: new Date().toISOString().split("T")[0],
        },
      }),
    });
  } catch (e) {
    // Silenciós — l'usuari no ha de saber si ha fallat
    console.error("Airtable error:", e);
  }
}

// ─── LEAD BANNER COMPONENT ────────────────────────────────────
function LeadBanner({ onDone, onClose, isLimit, onEnterCode }) {
  const [leadForm, setLeadForm] = useState({
    nom: "",
    correu: "",
    telefon: "",
    pisos: "1",
    comentaris: "",
    propietari: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [gdpr, setGdpr] = useState(false);
  const [gdprErr, setGdprErr] = useState(false);

  // Bloqueja el scroll del body mentre el modal és obert
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  function onChange(e) {
    const { name, value } = e.target;
    setLeadForm((f) => ({ ...f, [name]: value }));
    setErrors((e) => ({ ...e, [name]: null }));
  }
  function validate() {
    const err = {};
    if (!leadForm.nom.trim()) err.nom = "El nom és obligatori";
    if (!leadForm.correu.trim() || !/\S+@\S+\.\S+/.test(leadForm.correu))
      err.correu = "Correu no vàlid";
    if (!leadForm.telefon.trim()) err.telefon = "El telèfon és obligatori";
    if (
      leadForm.propietari &&
      (!leadForm.pisos || parseInt(leadForm.pisos) < 1)
    )
      err.pisos = "Mínim 1 contracte";
    return err;
  }
  async function handleSubmit() {
    if (!gdpr) {
      setGdprErr(true);
      return;
    }
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    await submitToAirtable(leadForm);
    localStorage.setItem(LS_KEY, "true");
    document.body.style.overflow = "";
    setLoading(false);
    onDone();
  }
  const inp = (f) =>
    `w-full px-3 py-2.5 rounded-xl border text-sm bg-white transition-all focus:outline-none focus:ring-2 focus:ring-red-700/30 ${
      errors[f]
        ? "border-red-400 bg-red-50"
        : "border-stone-200 hover:border-stone-300"
    }`;

  if (isLimit) {
    return (
      <div
        className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
        style={{ background: "rgba(8,12,24,0.72)" }}
      >
        <div
          className="w-full sm:max-w-sm bg-white shadow-2xl flex flex-col"
          style={{ borderRadius: "20px 20px 0 0", overflow: "hidden" }}
        >
          {/* Capçalera */}
          <div
            className="px-6 pt-6 pb-5 relative"
            style={{
              background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
            }}
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-4 flex items-center justify-center w-7 h-7 rounded-full"
              style={{
                background: "rgba(255,255,255,.2)",
                border: "none",
                cursor: "pointer",
                color: "white",
                fontSize: ".9rem",
              }}
            >
              ✕
            </button>
            <img
              src="/logo.png"
              alt="Fercamp"
              className="h-7 object-contain mb-3"
              data-logo="white"
            />
            <h2
              style={{
                fontFamily: "Georgia, serif",
                color: "white",
                fontSize: "1.2rem",
                fontWeight: 700,
                lineHeight: 1.25,
                margin: 0,
              }}
            >
              Vaja, sembla que has arribat al límit de simulacions! 🎯
            </h2>
          </div>
          {/* Cos */}
          <div className="px-6 py-6 space-y-3">
            <p className="text-base leading-relaxed" style={{ color: C.text }}>
              Necessites fer-ne més o assessorament?{" "}
              <strong>Contacta'ns i t'ajudem!</strong>
            </p>
            <a
              href="tel:+376738721"
              className="flex items-center justify-center gap-3 w-full py-4 rounded-2xl text-white font-bold text-lg transition-all hover:brightness-110 active:scale-[.99]"
              style={{
                background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
                textDecoration: "none",
                boxShadow: `0 4px 14px ${C.red}44`,
              }}
            >
              📞 738 721
            </a>
            <a
              href={WA_URL}
              target="_blank"
              rel="noopener"
              className="flex items-center justify-center gap-2 w-full py-4 rounded-2xl text-white font-bold text-lg transition-all hover:brightness-110"
              style={{ background: "#25d366", textDecoration: "none" }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp
            </a>
            {/* NOU: botó per entrar codi d'accés */}
            {onEnterCode && (
              <button
                onClick={onEnterCode}
                className="w-full py-3 rounded-2xl text-sm font-semibold transition-all hover:opacity-80"
                style={{
                  background: C.amberBg,
                  color: C.amber,
                  border: `1px solid ${C.amber}44`,
                  cursor: "pointer",
                }}
              >
                🔑 Tens un codi d'accés?
              </button>
            )}
            <button
              onClick={onClose}
              className="w-full py-3 rounded-2xl text-sm font-medium transition-all hover:opacity-80"
              style={{
                background: C.sand,
                color: C.muted,
                border: `1px solid ${C.border}`,
                cursor: "pointer",
              }}
            >
              Tornar enrere
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
      style={{ background: "rgba(8,12,24,0.72)" }}
    >
      <div
        className="w-full sm:max-w-md bg-white shadow-2xl flex flex-col"
        style={{ borderRadius: "20px 20px 0 0", maxHeight: "92vh" }}
      >
        {/* Capçalera compacta */}
        <div
          className="px-5 pt-4 pb-3 relative flex-shrink-0"
          style={{
            background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
            borderRadius: "20px 20px 0 0",
          }}
        >
          <button
            onClick={onClose}
            className="absolute top-3 right-4 flex items-center justify-center w-7 h-7 rounded-full"
            style={{
              background: "rgba(255,255,255,.2)",
              border: "none",
              cursor: "pointer",
              color: "white",
              fontSize: ".9rem",
            }}
          >
            ✕
          </button>
          <img
            src="/logo.png"
            alt="Fercamp"
            className="h-7 object-contain mb-2"
            data-logo="white"
          />
          <h2
            style={{
              fontFamily: "Georgia, serif",
              color: "white",
              fontSize: "1.05rem",
              fontWeight: 700,
              lineHeight: 1.2,
              margin: "0 0 4px",
            }}
          >
            {isLimit
              ? "Has arribat al límit de simulacions gratuïtes"
              : "Vols rebre assessorament personalitzat?"}
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,.75)",
              fontSize: ".75rem",
              lineHeight: 1.4,
              margin: 0,
            }}
          >
            {isLimit
              ? "Deixa'ns les teves dades i et desbloquejem l'accés. Et contactem sense compromís."
              : "Deixa'ns les teves dades i et contactem per resoldre els teus dubtes sobre la descongelació."}
          </p>
        </div>

        {/* Formulari scrollable */}
        <div
          className="overflow-y-auto flex-1 px-5 py-3 space-y-3"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <div className="grid grid-cols-2 gap-2.5">
            <div>
              <label
                className="block text-xs font-semibold uppercase tracking-widest mb-1"
                style={{ color: C.muted }}
              >
                Nom
              </label>
              <input
                name="nom"
                value={leadForm.nom}
                onChange={onChange}
                placeholder="El teu nom"
                className={inp("nom")}
              />
              {errors.nom && (
                <p className="text-red-500 text-xs mt-0.5">{errors.nom}</p>
              )}
            </div>
            <div>
              <label
                className="block text-xs font-semibold uppercase tracking-widest mb-1"
                style={{ color: C.muted }}
              >
                Telèfon
              </label>
              <input
                name="telefon"
                value={leadForm.telefon}
                onChange={onChange}
                placeholder="+376 XXX XXX"
                className={inp("telefon")}
              />
              {errors.telefon && (
                <p className="text-red-500 text-xs mt-0.5">{errors.telefon}</p>
              )}
            </div>
          </div>

          <div>
            <label
              className="block text-xs font-semibold uppercase tracking-widest mb-1"
              style={{ color: C.muted }}
            >
              Correu electrònic
            </label>
            <input
              name="correu"
              type="email"
              value={leadForm.correu}
              onChange={onChange}
              placeholder="correu@exemple.com"
              className={inp("correu")}
            />
            {errors.correu && (
              <p className="text-red-500 text-xs mt-0.5">{errors.correu}</p>
            )}
          </div>

          {leadForm.propietari && (
            <div>
              <label
                className="block text-xs font-semibold uppercase tracking-widest mb-1"
                style={{ color: C.muted }}
              >
                Contractes afectats
              </label>
              <input
                name="pisos"
                type="number"
                min="1"
                value={leadForm.pisos}
                onChange={onChange}
                placeholder="1"
                className={inp("pisos")}
              />
              {errors.pisos && (
                <p className="text-red-500 text-xs mt-0.5">{errors.pisos}</p>
              )}
            </div>
          )}
          <div>
            <label
              className="block text-xs font-semibold uppercase tracking-widest mb-1"
              style={{ color: C.muted }}
            >
              Comentaris{" "}
              <span
                style={{
                  color: C.hint,
                  fontWeight: 400,
                  textTransform: "none",
                }}
              >
                (opcional)
              </span>
            </label>
            <input
              name="comentaris"
              value={leadForm.comentaris}
              onChange={onChange}
              placeholder="Dubtes..."
              className={inp("comentaris")}
            />
          </div>

          {/* Propietari o llogater */}
          <div>
            <label
              className="block text-xs font-semibold uppercase tracking-widest mb-2"
              style={{ color: C.muted }}
            >
              Ets propietari o llogater?
            </label>
            <div className="grid grid-cols-2 gap-2">
              {[
                { val: true, label: "🏠 Propietari" },
                { val: false, label: "🔑 Llogater" },
              ].map(({ val, label }) => (
                <button
                  key={String(val)}
                  type="button"
                  onClick={() =>
                    setLeadForm((f) => ({ ...f, propietari: val }))
                  }
                  className="py-2.5 rounded-xl text-sm font-semibold transition-all"
                  style={{
                    background: leadForm.propietari === val ? C.red : C.sand,
                    color: leadForm.propietari === val ? "white" : C.muted,
                    border: `1.5px solid ${leadForm.propietari === val ? C.red : C.border}`,
                    cursor: "pointer",
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-start gap-2.5">
            <input
              type="checkbox"
              id="gdpr-check"
              checked={gdpr}
              onChange={(e) => {
                setGdpr(e.target.checked);
                setGdprErr(false);
              }}
              className="mt-0.5 flex-shrink-0 w-4 h-4 cursor-pointer"
              style={{ accentColor: C.red }}
            />
            <label
              htmlFor="gdpr-check"
              className="text-xs leading-relaxed cursor-pointer"
              style={{ color: C.muted }}
            >
              Accepto la{" "}
              <a
                href="https://www.fercamp.com/politica-de-privacitat"
                target="_blank"
                rel="noopener"
                style={{ color: C.red, textDecoration: "underline" }}
              >
                Política de Privacitat
              </a>{" "}
              d'Immobiliària Fercamp. Dades no cedides a tercers.
            </label>
          </div>
          {gdprErr && (
            <p className="text-red-500 text-xs">
              ⚠ Has d'acceptar la política de privacitat.
            </p>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full py-3 rounded-2xl text-white font-semibold text-sm transition-all hover:brightness-110 active:scale-[.99] disabled:opacity-60"
            style={{
              background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
              border: "none",
              cursor: loading ? "wait" : "pointer",
              boxShadow: `0 4px 14px ${C.red}44`,
            }}
          >
            {loading ? "Enviant..." : "Enviar formulari →"}
          </button>
          <div style={{ height: 8 }} />
        </div>
      </div>
    </div>
  );
}

function InfoModal({ onClose }) {
  // Bloqueja scroll del body mentre el modal és obert
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const LIB_YEARS = [
    {
      year: "2027",
      cond: "Contractes signats el 2012 o anteriors, o preu < 6€/m²",
    },
    {
      year: "2028",
      cond: "Contractes signats entre 2013–2015, o preu < 7€/m²",
    },
    {
      year: "2029",
      cond: "Contractes signats entre 2016–2018, o preu < 8€/m²",
    },
    { year: "2030", cond: "Contractes signats entre 2019–2021" },
  ];
  const TABLE = [
    ["≤ 7 €/m²", "6% + IPC"],
    ["> 7 i ≤ 8 €/m²", "5% + IPC"],
    ["> 8 i ≤ 9 €/m²", "4% + IPC"],
    ["> 9 i ≤ 10 €/m²", "3% + IPC"],
    ["> 10 i ≤ 12 €/m²", "2% + IPC"],
    ["> 12 €/m²", "1% + IPC"],
  ];
  const EXCLUSIONS = [
    "Lloguers superiors a 2.500€/mes (exclosos aparcament, trasters i subministraments del còmput)",
    "Habitatges unifamiliars",
    "Habitatges que requereixen obres que n'impedeixen l'arrendament (art. 127 i 134 LGOTU)",
    "Habitatges arrendats a residents sense activitat lucrativa",
    "Habitatges adquirits per destinar-los a residència habitual i permanent del propietari",
    "Habitatges que el propietari vol recuperar per a ús propi o familiar com a residència habitual i permanent",
    "Habitatges per recuperar a favor de treballadors amb residència al país des de fa ≥ 2 anys, o personal qualificat amb contracte amb clàusula de permanència de ≥ 2 anys",
    "Habitatges desocupats per causa imputable o a iniciativa de l'arrendatari",
    "Contractes signats a partir de l'1 de gener del 2022",
  ];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center"
      style={{ background: "rgba(8,12,24,0.65)" }}
      onClick={onClose}
    >
      <div
        className="w-full sm:max-w-lg bg-white shadow-2xl flex flex-col"
        style={{
          borderRadius: "24px 24px 0 0",
          maxHeight: "88vh",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header sticky */}
        <div
          className="flex items-center justify-between px-5 pt-5 pb-3 flex-shrink-0"
          style={{ borderBottom: `1px solid ${C.border}` }}
        >
          <h2
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "1.1rem",
              color: C.text,
              fontWeight: 600,
              margin: 0,
            }}
          >
            Claus de la descongelació
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-full"
            style={{
              background: C.sand,
              border: "none",
              cursor: "pointer",
              fontSize: ".9rem",
              color: C.muted,
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>

        {/* Scrollable content */}
        <div
          className="overflow-y-auto flex-1 px-5 py-4"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          {/* Anys d'alliberament */}
          <div className="mb-4">
            <div
              className="text-xs font-bold uppercase tracking-widest mb-2"
              style={{ color: C.muted }}
            >
              Quan s'allibera el teu contracte
            </div>
            <div
              className="rounded-2xl overflow-hidden"
              style={{ border: `1px solid ${C.border}` }}
            >
              {LIB_YEARS.map((r, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 px-4 py-3"
                  style={{
                    borderBottom: i < 3 ? `1px solid ${C.border}` : "none",
                    background: i % 2 === 0 ? "white" : C.cream,
                  }}
                >
                  <div
                    className="flex-shrink-0 px-2 py-0.5 rounded-lg text-xs font-bold"
                    style={{ background: C.red, color: "white", marginTop: 1 }}
                  >
                    {r.year}
                  </div>
                  <div
                    className="text-xs leading-relaxed"
                    style={{ color: C.text }}
                  >
                    {r.cond}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Taula increments */}
          <div className="mb-4">
            <div
              className="text-xs font-bold uppercase tracking-widest mb-2"
              style={{ color: C.muted }}
            >
              Increment màxim al nou contracte
            </div>
            <div
              className="rounded-2xl overflow-hidden"
              style={{ border: `1px solid ${C.border}` }}
            >
              <div className="px-4 py-2" style={{ background: C.red }}>
                <div
                  style={{
                    color: "white",
                    fontSize: ".85rem",
                    fontWeight: 600,
                  }}
                >
                  Taula oficial d'increments anuals (5 anys)
                </div>
                <div
                  style={{ color: "rgba(255,255,255,.5)", fontSize: ".65rem" }}
                >
                  Font: Llei 11/2026 · Govern d'Andorra · 4 juny 2026
                </div>
              </div>
              <table className="w-full" style={{ fontSize: ".85rem" }}>
                <tbody>
                  {TABLE.map(([range, inc], i) => (
                    <tr
                      key={i}
                      style={{
                        borderBottom: i < 5 ? `1px solid ${C.border}` : "none",
                        background: i % 2 === 0 ? "white" : C.cream,
                      }}
                    >
                      <td className="px-4 py-2" style={{ color: C.text }}>
                        {range}
                      </td>
                      <td
                        className="px-4 py-2 text-right font-semibold"
                        style={{ color: C.red }}
                      >
                        {inc}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Exclusions */}
          <div className="mb-3">
            <div
              className="text-xs font-bold uppercase tracking-widest mb-2"
              style={{ color: C.muted }}
            >
              Contractes exclosos de la llei
            </div>
            <div
              className="rounded-2xl p-4 space-y-2"
              style={{ background: C.sand, border: `1px solid ${C.border}` }}
            >
              {EXCLUSIONS.map((ex, i) => (
                <div
                  key={i}
                  className="flex items-start gap-2 text-xs leading-relaxed"
                  style={{ color: C.muted }}
                >
                  <span
                    className="flex-shrink-0 mt-0.5"
                    style={{ color: C.hint }}
                  >
                    ✕
                  </span>
                  <span>{ex}</span>
                </div>
              ))}
            </div>
          </div>

          <p className="text-xs text-center py-2" style={{ color: C.hint }}>
            Basat en la Llei 11/2026 · Govern d'Andorra · 4 juny 2026
          </p>
          <a
            href="https://www.bopa.ad/Documents/Detall?doc=CGL_2026_06_23_11_50_53"
            target="_blank"
            rel="noopener"
            className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl text-sm font-semibold transition-all hover:brightness-110"
            style={{
              background: C.sand,
              color: C.text,
              border: `1px solid ${C.border}`,
              textDecoration: "none",
            }}
          >
            📄 Llegir la Llei 11/2026 (Consell General)
          </a>
          <div style={{ height: 4 }} />
        </div>
      </div>
    </div>
  );
}

// ─── BUSINESS LOGIC ───────────────────────────────────────────
function getStructuralRate(price) {
  if (price <= 7) return 0.06;
  if (price <= 8) return 0.05;
  if (price <= 9) return 0.04;
  if (price <= 10) return 0.03;
  if (price <= 12) return 0.02;
  return 0.01;
}
function getLiberationYear(year, price) {
  const y = parseInt(year);
  if (y >= 2022) return "free";
  if (y <= 2012 || price < 6) return 2027;
  if (y <= 2015 || price < 7) return 2028;
  if (y <= 2018 || price < 8) return 2029;
  if (y <= 2021) return 2030;
  return null;
}

const r2 = (n) => Math.round(n * 100) / 100;
const fEur = (n) => n.toFixed(2).replace(".", ",") + "\u00a0€";
const fPct = (n) =>
  (n >= 0 ? "+" : "") + (n * 100).toFixed(1).replace(".", ",") + "%";

function simulate({ contractYear, m2, parish, rent, ipc: ipcRaw }) {
  const m2f = parseFloat(m2);
  const rentf = parseFloat(rent);
  const y = parseInt(contractYear);
  const ipcInput = parseFloat(ipcRaw) || 2.5;
  const ipc = Math.min(ipcInput, 2.5) / 100;
  if (!m2f || !rentf || !y || !parish) return null;
  const pricePerM2 = r2(rentf / m2f);
  const libYear = getLiberationYear(y, pricePerM2);
  if (libYear === "free") return { type: "free", pricePerM2 };
  if (!libYear) return null;
  const parishData = PARISH_BY_ID[parish];
  if (!parishData) return null;
  const parishPrice2026 = parishData.price;
  const structRate = getStructuralRate(pricePerM2);

  const frozenRows = [
    {
      year: 2026,
      rent: rentf,
      phase: "current",
      label: "Lloguer actual (congelat)",
    },
  ];
  let r = rentf;
  for (let yr = 2027; yr < libYear; yr++) {
    r = r2(r * (1 + ipc));
    frozenRows.push({
      year: yr,
      rent: r,
      phase: "frozen",
      label: `Pròrroga · IPC ${fPct(ipc)}`,
    });
  }
  const rentAtLib = r;
  const priceAtLib = r2(rentAtLib / m2f);

  // El preu de referència només puja amb IPC durant els anys en què el lloguer
  // també puja amb IPC (anys de pròrroga: de 2027 a libYear-1).
  // Si libYear=2027, no hi ha cap any de pròrroga → 0 anys d'IPC.
  const yearsUntilLib = Math.max(0, libYear - 2027);
  const parishPrice = r2(parishPrice2026 * Math.pow(1 + ipc, yearsUntilLib));

  const sysBRows = [];
  let rB = rentAtLib;
  for (let i = 0; i < 5; i++) {
    const prev = rB;
    rB = r2(rB * (1 + structRate + ipc));
    sysBRows.push({
      year: libYear + i,
      rent: rB,
      prev,
      annualPct: structRate + ipc,
      label: `Any ${i + 1} · ${fPct(structRate)} estructural + IPC`,
      phase: i === 0 ? "lib" : "b",
    });
  }

  const belowParish = priceAtLib < parishPrice;
  let sysCRows = [],
    sysCUsesB45 = false;
  if (belowParish) {
    const targetRent = r2(parishPrice * m2f);
    const step = r2((targetRent - rentAtLib) / 3);
    let rC = rentAtLib;
    for (let i = 0; i < 3; i++) {
      const prev = rC;
      rC = r2((rC + step) * (1 + ipc));
      sysCRows.push({
        year: libYear + i,
        rent: rC,
        prev,
        annualPct: (rC - prev) / prev,
        label: `Any ${i + 1} · +${fEur(step).trim()}/mes (1/3 diferència) + IPC`,
        phase: i === 0 ? "lib" : "c",
      });
    }
    sysCUsesB45 = sysCRows[2].rent < sysBRows[2].rent;
    let rC4 = sysCRows[2].rent;
    for (let i = 3; i < 5; i++) {
      const prev = rC4;
      const rate = sysCUsesB45 ? structRate + ipc : ipc;
      rC4 = r2(rC4 * (1 + rate));
      sysCRows.push({
        year: libYear + i,
        rent: rC4,
        prev,
        annualPct: rate,
        label: sysCUsesB45
          ? `Any ${i + 1} · ${fPct(structRate)} + IPC (s\'aplica taula oficial)`
          : `Any ${i + 1} · IPC`,
        phase: sysCUsesB45 ? "c45b" : "c45",
      });
    }
  }
  const recSysC = belowParish && sysCRows[4]?.rent > sysBRows[4]?.rent;

  return {
    type: "normal",
    pricePerM2,
    priceAtLib,
    libYear,
    parishPrice,
    parishPrice2026,
    yearsUntilLib,
    parishName: parishData.name,
    belowParish,
    structRate,
    ipc,
    ipcInput,
    rentAtLib,
    targetRent: belowParish ? r2(parishPrice * m2f) : null,
    frozenRows,
    sysBRows,
    sysCRows,
    sysCUsesB45,
    recSysC,
    m2f,
    initialRent: rentf,
  };
}

function encodeParams(form) {
  const p = new URLSearchParams({
    y: form.contractYear,
    m: form.m2,
    p: form.parish,
    r: form.rent,
    i: form.ipc,
  });
  return `${window.location.origin}${window.location.pathname}?${p.toString()}`;
}
function parseParams() {
  const p = new URLSearchParams(window.location.search);
  if (!p.get("y") || !p.get("m") || !p.get("p") || !p.get("r")) return null;
  return {
    contractYear: p.get("y"),
    m2: p.get("m"),
    parish: p.get("p"),
    rent: p.get("r"),
    ipc: p.get("i") || "2.5",
  };
}

// ─── SHARED COMPONENTS ────────────────────────────────────────
function NavBar({ onBack, onHome }) {
  return (
    <nav
      className="sticky top-0 z-50 flex items-center justify-between px-4 sm:px-6 py-3"
      style={{ background: C.red, borderBottom: `1px solid ${C.redDark}` }}
    >
      <button
        onClick={onHome || onBack}
        className="flex items-center gap-3 hover:opacity-85 transition-opacity"
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <img
          src="/logo.png"
          alt="Fercamp"
          className="h-9 object-contain"
          data-logo="white"
        />
        <div className="text-left">
          <div
            style={{
              color: "white",
              fontSize: ".82rem",
              fontWeight: 700,
              letterSpacing: ".07em",
              textTransform: "uppercase",
            }}
          >
            Immobiliaria Andorra
          </div>
          <div style={{ color: "rgba(255,255,255,.6)", fontSize: ".68rem" }}>
            Simulador de lloguers · 2026
          </div>
        </div>
      </button>
      <div className="flex items-center gap-2">
        <a
          href="https://simulador-fercamp.web.app"
          target="_blank"
          rel="noopener"
          className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium hover:opacity-85 transition-opacity"
          style={{
            background: "rgba(255,255,255,.15)",
            color: "rgba(255,255,255,.9)",
            textDecoration: "none",
            border: "1px solid rgba(255,255,255,.2)",
          }}
        >
          🏠 Simulador hipotecari
        </a>
        <a
          href={`mailto:${EMAIL}`}
          className="flex items-center gap-1.5 px-3 sm:px-4 py-1.5 rounded-lg text-xs font-semibold hover:opacity-85 transition-opacity"
          style={{ background: "white", color: C.red, textDecoration: "none" }}
        >
          Contactar
        </a>
      </div>
    </nav>
  );
}

function MortgageBanner() {
  return (
    <div
      className="flex items-start gap-3 px-4 py-4 rounded-2xl"
      style={{ background: C.amberBg, border: "1px solid #f0c878" }}
    >
      <div className="text-xl flex-shrink-0 mt-0.5">🏠</div>
      <div className="text-sm leading-relaxed" style={{ color: "#7a5000" }}>
        <strong>Estàs pensant en comprar a Andorra?</strong> Descobreix les
        ajudes del Govern (aval 100%, el Govern paga els interessos 7 anys) al
        nostre{" "}
        <a
          href="https://simulador-fercamp.web.app"
          target="_blank"
          rel="noopener"
          style={{ color: C.amber, fontWeight: 700 }}
        >
          Simulador Hipotecari →
        </a>
      </div>
    </div>
  );
}

function InstagramBanner() {
  return (
    <a
      href="https://www.instagram.com/immobiliaria.fercamp/"
      target="_blank"
      rel="noopener"
      className="flex items-center gap-4 px-5 py-4 rounded-2xl transition-all hover:brightness-95 active:scale-[.99]"
      style={{
        background:
          "linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%)",
        textDecoration: "none",
      }}
    >
      <svg
        className="flex-shrink-0"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
      <div className="flex-1">
        <div
          className="font-semibold text-sm"
          style={{ color: "white", lineHeight: 1.3 }}
        >
          Segueix-nos a Instagram
        </div>
        <div
          className="text-xs mt-0.5"
          style={{ color: "rgba(255,255,255,.85)" }}
        >
          @immobiliaria.fercamp · Novetats del sector immobiliari i propietats
          disponibles
        </div>
      </div>
      <div
        className="flex-shrink-0 text-sm font-bold"
        style={{ color: "white" }}
      >
        →
      </div>
    </a>
  );
}

function Disclaimer() {
  return (
    <div className="py-6" style={{ maxWidth: 680, margin: "0 auto" }}>
      <div
        className="mb-3 p-4 rounded-2xl text-sm leading-relaxed"
        style={{
          background: "#fffbeb",
          border: "1px solid #f59e0b",
          color: "#78350f",
        }}
      >
        <div className="font-bold mb-1">ℹ️ Basat en la Llei 11/2026</div>
        Aquesta simulació es basa en la{" "}
        <strong>
          Llei 11/2026, del 4 de juny, d'aprovació del règim jurídic aplicable
          als contractes d'arrendament d'habitatge per a residència habitual i
          permanent per al període 2027–2030
        </strong>
        , aprovada pel Consell General el 4 de juny de 2026.
      </div>
      <p
        className="text-center text-xs leading-relaxed"
        style={{ color: "#b8a898" }}
      >
        <strong style={{ color: "#8a7060" }}>
          Immobiliària Fercamp no es fa responsable
        </strong>{" "}
        de cap decisió presa basant-se en aquesta eina, ni de possibles errors
        en els càlculs. Llegiu el text definitiu de la llei i consulteu un
        professional.
      </p>
    </div>
  );
}

function ProvisionalBanner() {
  return (
    <div
      className="no-print flex items-start gap-3 p-4 rounded-2xl text-sm leading-relaxed"
      style={{
        background: "#fffbeb",
        border: "1px solid #f59e0b",
        color: "#78350f",
      }}
    >
      <span className="text-lg flex-shrink-0">⚠️</span>
      <div>
        <strong>
          Simulació basada en la Llei 11/2026, del 4 de juny, d'aprovació del
          règim jurídic aplicable als contractes d'arrendament d'habitatge per a
          residència habitual i permanent per al període 2027–2030.
        </strong>{" "}
        Immobiliària Fercamp no es fa responsable de cap decisió presa basant-se
        en aquesta eina, ni de possibles errors en els càlculs. Llegiu el text
        definitiu de la llei i consulteu un professional.
      </div>
    </div>
  );
}

// ─── PRINT CSS ────────────────────────────────────────────────
const PRINT_STYLE = `
@media print {
  body { background: white !important; font-family: Georgia, serif; }
  .no-print { display: none !important; }
  nav, .no-print { display: none !important; }
  .print-only { display: block !important; }
  .max-w-5xl { max-width: 100% !important; padding: 0 !important; }
  .rounded-3xl, .rounded-2xl, .rounded-xl { border-radius: 8px !important; }
  .space-y-5 > * + * { margin-top: 16px !important; }
  img[data-logo="white"] { display: none !important; }
  img[data-logo="print"] { display: block !important; }
  @page { margin: 1.5cm; size: A4; }
}
.print-only { display: none; }
img[data-logo="print"] { display: none; }
`;

// ─── TERRASSA MODAL ───────────────────────────────────────────
function TerrassaModal({ onClose }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const COEFS = [
    {
      t: "Terrassa coberta privativa",
      s: "(exterior cobert, obert com a mínim per un costat)",
      c: "0,50",
    },
    {
      t: "Terrassa descoberta privativa",
      s: "(exterior sense cobrir)",
      c: "0,30",
    },
    { t: "Balcó", s: "", c: "0,25" },
    { t: "Pati privatiu d'ús exclusiu", s: "", c: "0,30" },
    {
      t: "Porxo cobert",
      s: "(exterior cobert amb accés directe a l'habitatge)",
      c: "0,40",
    },
    {
      t: "Galeria tancada no climatitzada",
      s: "(tancament lleuger amb ús auxiliar)",
      c: "0,60",
    },
    { t: "Traster al mateix edifici", s: "", c: "0,25" },
    { t: "Traster amb accés directe des de l'habitatge", s: "", c: "0,30" },
  ];

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center"
      style={{ background: "rgba(8,12,24,0.65)" }}
      onClick={onClose}
    >
      <div
        className="w-full sm:max-w-lg bg-white shadow-2xl flex flex-col"
        style={{ borderRadius: "20px 20px 0 0", maxHeight: "88vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-5 pt-5 pb-3 flex-shrink-0"
          style={{ borderBottom: `1px solid ${C.border}` }}
        >
          <div>
            <h2
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "1.05rem",
                color: C.text,
                fontWeight: 600,
                margin: 0,
              }}
            >
              Coeficients de ponderació de superfícies
            </h2>
            <p style={{ fontSize: ".72rem", color: C.hint, margin: "2px 0 0" }}>
              Font: Llei 11/2026 · Govern d'Andorra · 4 juny 2026
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-full flex-shrink-0 ml-3"
            style={{
              background: C.sand,
              border: "none",
              cursor: "pointer",
              fontSize: ".9rem",
              color: C.muted,
            }}
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div
          className="overflow-y-auto flex-1 px-5 py-4"
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <p
            className="text-sm leading-relaxed mb-4"
            style={{ color: C.muted }}
          >
            Per calcular la superfície computable del teu habitatge, multiplica
            els m² de cada espai exterior pel seu coeficient i suma-ho a la
            superfície interior.
          </p>

          <div
            className="rounded-2xl overflow-hidden mb-4"
            style={{ border: `1px solid ${C.border}` }}
          >
            <div className="px-4 py-2.5" style={{ background: C.red }}>
              <div
                style={{ color: "white", fontSize: ".85rem", fontWeight: 600 }}
              >
                Tipus d'espai i coeficient
              </div>
            </div>
            {COEFS.map((row, i) => (
              <div
                key={i}
                className="flex items-center justify-between gap-3 px-4 py-3"
                style={{
                  borderBottom:
                    i < COEFS.length - 1 ? `1px solid ${C.border}` : "none",
                  background: i % 2 === 0 ? "white" : C.cream,
                }}
              >
                <div className="flex-1">
                  <div
                    className="text-sm font-medium"
                    style={{ color: C.text }}
                  >
                    {row.t}
                  </div>
                  {row.s && (
                    <div className="text-xs mt-0.5" style={{ color: C.hint }}>
                      {row.s}
                    </div>
                  )}
                </div>
                <div
                  className="flex-shrink-0 px-3 py-1 rounded-lg text-sm font-bold"
                  style={{
                    background: C.red + "15",
                    color: C.red,
                    minWidth: 44,
                    textAlign: "center",
                  }}
                >
                  ×{row.c}
                </div>
              </div>
            ))}
          </div>

          <div
            className="p-4 rounded-2xl text-sm leading-relaxed"
            style={{
              background: C.amberBg,
              border: "1px solid #f0c878",
              color: "#7a5000",
            }}
          >
            <strong>Exemple:</strong> Pis de 70 m² + terrassa descoberta de 10
            m²
            <br />
            Superfície computable = 70 + (10 × 0,30) = <strong>73 m²</strong>
          </div>

          <div style={{ height: 8 }} />
        </div>
      </div>
    </div>
  );
}

// ─── PAGE 1: FORM ─────────────────────────────────────────────
function FormPage({ onSubmit, form, setForm, onOpenBanner, limitReached }) {
  const [errors, setErrors] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [showTerrassa, setShowTerrassa] = useState(false);
  const ipcOver = (parseFloat(form.ipc) || 0) > 2.5;

  function onChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((e) => ({ ...e, [name]: null }));
  }
  function validate() {
    const err = {};
    const yr = parseInt(form.contractYear);
    if (!form.contractYear || isNaN(yr) || yr < 1950 || yr > 2025)
      err.contractYear = "Any vàlid entre 1950 i 2025";
    if (!form.m2 || parseFloat(form.m2) < 5) err.m2 = "Superfície mínima 5 m²";
    if (!form.parish) err.parish = "Selecciona la parròquia";
    if (!form.rent || parseFloat(form.rent) < 10) err.rent = "Mínim 10€";
    return err;
  }
  function handleSubmit() {
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    onSubmit(form);
  }

  const inp = (f) =>
    `w-full px-4 py-3 rounded-xl border text-base bg-white transition-all focus:outline-none focus:ring-2 ${
      errors[f]
        ? "border-red-400 bg-red-50 focus:ring-red-300"
        : "border-stone-200 hover:border-stone-300 focus:ring-red-700/30"
    }`;
  const lbl = "block text-xs font-semibold uppercase tracking-widest mb-2";

  return (
    <div className="min-h-screen" style={{ background: C.cream }}>
      {showInfo && <InfoModal onClose={() => setShowInfo(false)} />}
      {showTerrassa && <TerrassaModal onClose={() => setShowTerrassa(false)} />}
      <NavBar
        onBack={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        onHome={() => {
          window.history.replaceState({}, "", window.location.pathname);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />

      {/* HERO */}
      <div
        style={{
          background: `linear-gradient(150deg, ${C.redDark} 0%, ${C.red} 55%, ${C.redLight} 100%)`,
        }}
      >
        <div className="max-w-6xl mx-auto px-4 pt-12 pb-14">
          <div className="mb-7">
            <img
              src="/logo.png"
              alt="Fercamp"
              className="h-14 object-contain"
              data-logo="white"
            />
          </div>
          <div
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase mb-5"
            style={{
              background: "rgba(255,255,255,.15)",
              color: "rgba(255,255,255,.9)",
              border: "1px solid rgba(255,255,255,.25)",
            }}
          >
            ✅ Llei 11/2026 · Aprovada
          </div>
          <h1
            className="font-bold mb-4"
            style={{
              color: "white",
              fontSize: "clamp(2rem,5vw,3.5rem)",
              lineHeight: 1.1,
              fontFamily: "Georgia, serif",
            }}
          >
            La descongelació dels lloguers
            <br />
            arriba a Andorra. Entén-la.
          </h1>
          <p
            className="mb-8"
            style={{
              color: "rgba(255,255,255,.85)",
              maxWidth: 540,
              lineHeight: 1.8,
              fontSize: "1.05rem",
            }}
          >
            El Consell General ha aprovat la llei que allibera progressivament
            els lloguers congelats des del 2019. Siguis propietari o llogater,
            calcula l'impacte real en el teu contracte.
          </p>
          {/* CTAs hero */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => setShowInfo(true)}
              className="flex items-center gap-2 px-5 py-3 rounded-2xl text-sm font-semibold transition-all hover:brightness-110 active:scale-[.99]"
              style={{
                background: "rgba(255,255,255,.18)",
                color: "white",
                border: "1px solid rgba(255,255,255,.35)",
                cursor: "pointer",
              }}
            >
              📋 Vols saber com funciona? Llegeix aquí
            </button>
          </div>
          <p
            className="mt-5 mb-0 text-sm font-semibold"
            style={{
              color: "rgba(255,255,255,.55)",
              letterSpacing: ".04em",
              textTransform: "uppercase",
            }}
          >
            O si ja ho saps ↓ calcula directament
          </p>
        </div>
      </div>

      {/* LAYOUT — formulari centrat, info en modal */}
      <div
        style={{ background: "white", borderBottom: `1px solid ${C.border}` }}
      >
        <div className="max-w-xl mx-auto px-4 py-8">
          <div className="flex flex-col">
            {/* info disponible al modal InfoModal */}
            {/* Formulari — columna única, centrat */}
            <div className="w-full">
              <div
                className="bg-white rounded-3xl p-6 sm:p-8 shadow-sm"
                style={{ border: `1px solid ${C.border}` }}
              >
                <h2
                  className="font-semibold mb-1"
                  style={{
                    fontFamily: "Georgia, serif",
                    fontSize: "1.75rem",
                    color: C.text,
                  }}
                >
                  Calcula l'impacte en el teu contracte
                </h2>
                <p
                  className="mb-7"
                  style={{ color: C.muted, fontSize: ".95rem" }}
                >
                  Introdueix les dades del teu contracte per veure quan
                  s'allibera i com evoluciona la renda.
                </p>

                <div className="space-y-5 mb-5">
                  <div>
                    <label className={lbl} style={{ color: C.muted }}>
                      Any de signatura
                    </label>
                    <input
                      type="number"
                      name="contractYear"
                      value={form.contractYear}
                      onChange={onChange}
                      placeholder="p.ex. 2015"
                      min="1950"
                      max="2025"
                      className={inp("contractYear")}
                    />
                    {errors.contractYear && (
                      <p className="text-red-600 text-sm mt-1.5">
                        ⚠ {errors.contractYear}
                      </p>
                    )}
                    <p className="text-sm mt-1.5" style={{ color: C.hint }}>
                      Contractes del 2022+ no estan subjectes a la llei.
                    </p>
                  </div>

                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <label
                        className={lbl}
                        style={{ color: C.muted, margin: 0 }}
                      >
                        Superfície construïda (m²)
                      </label>
                      <button
                        type="button"
                        onClick={() => setShowTerrassa(true)}
                        className="flex items-center gap-1 text-xs font-semibold rounded-lg px-2 py-1 transition-all hover:opacity-80"
                        style={{
                          background: C.sand,
                          color: C.red,
                          border: `1px solid ${C.border}`,
                          cursor: "pointer",
                        }}
                      >
                        📐 Terrasses, balcons i altres
                      </button>
                    </div>
                    <input
                      type="number"
                      name="m2"
                      value={form.m2}
                      onChange={onChange}
                      placeholder="p.ex. 65"
                      min="5"
                      className={inp("m2")}
                    />
                    {errors.m2 && (
                      <p className="text-red-600 text-sm mt-1.5">
                        ⚠ {errors.m2}
                      </p>
                    )}
                    <p className="text-sm mt-1.5" style={{ color: C.hint }}>
                      Terrasses, balcons, trasters... computen amb coeficients
                      específics.{" "}
                      <button
                        type="button"
                        onClick={() => setShowTerrassa(true)}
                        style={{
                          color: C.red,
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          fontSize: "inherit",
                          textDecoration: "underline",
                        }}
                      >
                        Consulta la taula →
                      </button>
                    </p>
                  </div>

                  <div>
                    <label className={lbl} style={{ color: C.muted }}>
                      Parròquia
                    </label>
                    <select
                      name="parish"
                      value={form.parish}
                      onChange={onChange}
                      className={inp("parish")}
                    >
                      <option value="">Selecciona la parròquia...</option>
                      {PARISHES.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name} — Ref. {p.price.toFixed(2).replace(".", ",")}{" "}
                          €/m²
                        </option>
                      ))}
                    </select>
                    {errors.parish && (
                      <p className="text-red-600 text-sm mt-1.5">
                        ⚠ {errors.parish}
                      </p>
                    )}
                    <p className="text-sm mt-1.5" style={{ color: C.hint }}>
                      Preus de la disposició addicional de la llei de Govern.
                    </p>
                  </div>

                  <div>
                    <label className={lbl} style={{ color: C.muted }}>
                      Lloguer mensual net (€)
                    </label>
                    <input
                      type="number"
                      name="rent"
                      value={form.rent}
                      onChange={onChange}
                      placeholder="p.ex. 650"
                      min="10"
                      className={inp("rent")}
                    />
                    {errors.rent && (
                      <p className="text-red-600 text-sm mt-1.5">
                        ⚠ {errors.rent}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className={lbl} style={{ color: C.muted }}>
                      IPC estimat per als càlculs (%)
                    </label>
                    <input
                      type="number"
                      name="ipc"
                      value={form.ipc}
                      onChange={onChange}
                      placeholder="2.5"
                      min="0"
                      max="20"
                      step="0.1"
                      className={inp("ipc")}
                    />
                    {/* #2 — avís IPC sota l'input, no a la dreta */}
                    <div
                      className="mt-2 text-sm leading-relaxed px-3 py-2 rounded-lg"
                      style={
                        ipcOver
                          ? {
                              background: "#fff3e0",
                              border: "1px solid #ffb74d",
                              color: "#7c4a00",
                            }
                          : {
                              background: "#fef0f0",
                              border: `1px solid ${C.redLight}44`,
                              color: C.red,
                            }
                      }
                    >
                      {ipcOver ? (
                        <>
                          IPC introduït: <strong>{form.ipc}%</strong>. La llei
                          fixa un <strong>màxim del 2,5%</strong> — els càlculs
                          es faran amb el 2,5%.
                        </>
                      ) : (
                        <>
                          La llei fixa un <strong>IPC màxim del 2,5%</strong>,
                          independentment de l'IPC real del país.
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Avís lloguer net */}
                <div
                  className="mb-6 p-4 rounded-2xl text-sm leading-relaxed"
                  style={{
                    background: C.amberBg,
                    border: "1px solid #f0c878",
                    color: "#7a5000",
                  }}
                >
                  <div className="font-bold mb-2">
                    ⚠️ Introdueix el lloguer NET de l'habitatge
                  </div>
                  <ul className="space-y-1 ml-1 mb-2">
                    <li>
                      • <strong>Subministraments</strong> (calefacció, aigua,
                      llum): dedueix-los si estan inclosos dins el lloguer.
                    </li>
                    <li>
                      • <strong>Aparcament</strong>: dedueix el seu import si
                      estan inclosos.
                    </li>
                  </ul>

                  <details className="group">
                    <summary
                      className="flex items-center gap-2 text-sm font-semibold cursor-pointer select-none list-none"
                      style={{ color: C.red }}
                    >
                      <span className="group-open:hidden">▶</span>
                      <span className="hidden group-open:inline">▼</span>
                      Més detalls
                    </summary>
                    <div className="mt-3 rounded-2xl overflow-hidden">
                      <div className="mb-2">
                        <strong>Article 4.3</strong> En cas que la renda de
                        lloguer de l’habitatge inclogui places d’aparcament o
                        serveis i subministraments complementaris sense que
                        estiguin desglossats, aquestes places i els serveis i
                        subministraments es descompten de la renda indicada en
                        el contracte, sempre que no es disposi de comptadors
                        individuals o que no se’n pugui individualitzar el
                        consum, d’acord amb els preus establerts en la
                        convocatòria per a l’ajut per a l’habitatge de lloguer
                        vigent en cada moment.{" "}
                        <a
                          href="https://www.e-tramits.ad/tramits/ca/ajut-per-a-lhabitatge-de-lloguer/p/GV000746"
                          target="_blank"
                          rel="noopener"
                          style={{ color: C.red, textDecoration: "underline" }}
                        >
                          Més informació
                        </a>
                      </div>
                    </div>
                  </details>
                </div>

                <button
                  onClick={handleSubmit}
                  className="w-full py-4 px-8 rounded-2xl text-white font-semibold text-base transition-all hover:brightness-110 active:scale-[.99]"
                  style={{
                    background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
                    border: "none",
                    cursor: "pointer",
                    boxShadow: `0 4px 18px ${C.red}55`,
                  }}
                >
                  {limitReached && LOCK_SIMULATION
                    ? "Has assolit el límit de simulacions — Contacta'ns →"
                    : "Calcula l'evolució del lloguer →"}
                </button>

                {/* Botó assessorament opcional — visible quan BANNER_ACTIVE */}
                {onOpenBanner && (
                  <button
                    onClick={onOpenBanner}
                    className="w-full py-3 rounded-2xl text-sm font-medium transition-all hover:opacity-80"
                    style={{
                      background: C.sand,
                      color: C.muted,
                      border: `1px solid ${C.border}`,
                      cursor: "pointer",
                      marginTop: 8,
                    }}
                  >
                    Tens dubtes? T'ajudem a solucionar-los
                  </button>
                )}
              </div>

              <div className="mt-5">
                <MortgageBanner />
              </div>

              <div className="mt-3">
                <InstagramBanner />
              </div>
              <div
                className="mt-5 rounded-3xl overflow-hidden"
                style={{
                  background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
                }}
              >
                <div className="px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                  <div>
                    <h3
                      className="mb-1 font-semibold"
                      style={{
                        fontFamily: "Georgia, serif",
                        color: "white",
                        fontSize: "1.15rem",
                      }}
                    >
                      Tens dubtes sobre el teu contracte?
                    </h3>
                    <p
                      className="text-sm leading-relaxed"
                      style={{ color: "rgba(255,255,255,.8)" }}
                    >
                      Som especialistes en el mercat de lloguer d'Andorra i
                      t'ajudem a entendre la llei.
                    </p>
                  </div>
                  <a
                    href={`mailto:${EMAIL}`}
                    className="flex-shrink-0 px-5 py-3 rounded-2xl text-sm font-semibold hover:opacity-90 transition-opacity"
                    style={{
                      background: "white",
                      color: C.red,
                      textDecoration: "none",
                    }}
                  >
                    Contacta'ns →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-xl mx-auto px-4">
        <Disclaimer />
      </div>
    </div>
  );
}

// ─── PAGE 2: RESULTS ──────────────────────────────────────────
// ─── CHART HELPERS ────────────────────────────────────────────
function BarChart({ rows, initialRent, maxRent, PS, fEur, C }) {
  return (
    <div className="space-y-2">
      {rows.map((row, i, arr) => {
        const pct = Math.max(8, (row.rent / maxRent) * 100);
        const ps = PS[row.phase] || PS.b;
        const prev = i > 0 ? arr[i - 1].rent : null;
        const annPct = prev
          ? (((row.rent - prev) / prev) * 100).toFixed(1).replace(".", ",")
          : null;
        const cumPct = (((row.rent - initialRent) / initialRent) * 100)
          .toFixed(1)
          .replace(".", ",");
        let rightLabel =
          row.phase === "current"
            ? "Congelat"
            : row.phase === "frozen"
              ? `Pròrroga · IPC +${annPct}%`
              : row.label || "";
        return (
          <div key={i} className="flex items-center gap-2.5">
            <div
              className="w-10 text-right flex-shrink-0 text-sm font-bold"
              style={{ color: row.phase === "lib" ? "#16a34a" : C.hint }}
            >
              {row.year}
            </div>
            <div
              className="flex-1 relative rounded-lg overflow-hidden"
              style={{ height: 34, background: C.sand }}
            >
              <div
                className="h-full rounded-lg flex items-center justify-end pr-3"
                style={{
                  width: `${pct}%`,
                  minWidth: 90,
                  background: ps.bd + "bb",
                }}
              >
                <span
                  className="text-xs font-bold"
                  style={{
                    color: "#fff",
                    textShadow: "0 1px 2px rgba(0,0,0,.35)",
                  }}
                >
                  {fEur(row.rent).trim()}
                </span>
              </div>
            </div>
            <div className="hidden sm:flex flex-col items-end w-44 flex-shrink-0">
              <span
                className="text-xs font-semibold text-right leading-tight"
                style={{ color: ps.bd }}
              >
                {rightLabel}
              </span>
              <span className="text-xs" style={{ color: C.hint }}>
                +{cumPct}% total
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function ChartTabs({
  frozenRows,
  sysBRows,
  sysCRows,
  initialRent,
  maxRent,
  PS,
  fEur,
  fPct,
  C,
}) {
  const [tab, setTab] = useState(0);
  const datasets = [
    {
      label: "Taula oficial",
      rows: [...frozenRows, ...sysBRows],
      color: "#a855f7",
      legend: [
        { c: "#3b82f6", l: "Congelat" },
        { c: "#f59e0b", l: "Pròrroga" },
        { c: "#16a34a", l: "Alliberat" },
        { c: "#a855f7", l: "Nou contracte" },
      ],
    },
    {
      label: "Aproximació ref.",
      rows: [...frozenRows, ...sysCRows],
      color: "#ea580c",
      legend: [
        { c: "#3b82f6", l: "Congelat" },
        { c: "#f59e0b", l: "Pròrroga" },
        { c: "#16a34a", l: "Alliberat" },
        { c: "#ea580c", l: "Nou contracte" },
        { c: "#a855f7", l: "Anys 4-5" },
      ],
    },
  ];
  return (
    <div>
      <div className="flex gap-2 mb-4">
        {datasets.map((d, i) => (
          <button
            key={i}
            onClick={() => setTab(i)}
            className="px-4 py-2 rounded-xl text-sm font-semibold transition-all"
            style={{
              background: tab === i ? d.color : C.sand,
              color: tab === i ? "white" : C.muted,
              border: `1.5px solid ${tab === i ? d.color : C.border}`,
              cursor: "pointer",
            }}
          >
            {d.label}
          </button>
        ))}
      </div>
      <BarChart
        rows={datasets[tab].rows}
        initialRent={initialRent}
        maxRent={maxRent}
        PS={PS}
        fEur={fEur}
        C={C}
      />
      <div className="mt-4 flex flex-wrap gap-3 text-sm">
        {datasets[tab].legend.map((x, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <div
              className="w-3 h-3 rounded-sm flex-shrink-0"
              style={{ background: x.c }}
            />
            <span style={{ color: C.muted }}>{x.l}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── PAGE 2: RESULTS ──────────────────────────────────────────
function ResultsPage({ result, form, onBack, onNewSimulation, onOpenBanner }) {
  const [copied, setCopied] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  function handleShare() {
    const url = encodeParams(form);
    if (navigator.clipboard)
      navigator.clipboard.writeText(url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3500);
      });
  }

  if (!result)
    return (
      <div className="min-h-screen" style={{ background: C.cream }}>
        <NavBar onBack={onBack} onHome={onNewSimulation} />
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <p className="mb-4 text-base" style={{ color: C.muted }}>
            No s'han pogut calcular els resultats. Comprova les dades.
          </p>
          <button
            onClick={onBack}
            className="px-6 py-3 rounded-2xl text-white font-medium"
            style={{ background: C.red, border: "none", cursor: "pointer" }}
          >
            ← Tornar
          </button>
        </div>
      </div>
    );

  if (result.type === "free")
    return (
      <div className="min-h-screen" style={{ background: C.cream }}>
        <NavBar onBack={onBack} onHome={onNewSimulation} />
        <div className="max-w-4xl mx-auto px-4 py-16">
          <div
            className="bg-white rounded-3xl p-8 sm:p-12 text-center"
            style={{ border: `1px solid ${C.border}` }}
          >
            <div className="text-5xl mb-4">✅</div>
            <h2
              className="font-semibold mb-3"
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "1.8rem",
                color: C.text,
              }}
            >
              Contracte no afectat
            </h2>
            <p
              className="leading-relaxed max-w-lg mx-auto mb-4"
              style={{ color: C.muted, fontSize: "1rem" }}
            >
              Contractes signats des del 2022 no estan subjectes a la pròrroga
              forçosa. El teu lloguer ja és de mercat lliure.
            </p>
            <div
              className="inline-block px-4 py-1.5 rounded-full font-semibold mb-6"
              style={{
                background: "#dcfce7",
                color: "#15803d",
                fontSize: "1rem",
              }}
            >
              Preu/m²: {result.pricePerM2.toFixed(2).replace(".", ",")} €/m²
            </div>
            <br />
            <button
              onClick={onBack}
              className="px-8 py-3 rounded-2xl text-white font-medium"
              style={{ background: C.red, border: "none", cursor: "pointer" }}
            >
              ← Tornar
            </button>
          </div>
        </div>
      </div>
    );

  const {
    pricePerM2,
    priceAtLib,
    libYear,
    parishPrice,
    parishPrice2026,
    yearsUntilLib,
    parishName,
    belowParish,
    structRate,
    ipc,
    ipcInput,
    rentAtLib,
    targetRent,
    frozenRows,
    sysBRows,
    sysCRows,
    sysCUsesB45,
    recSysC,
    m2f,
    initialRent,
  } = result;

  const frozenCount = libYear - 2027;
  const maxRent = Math.max(
    ...frozenRows.map((r) => r.rent),
    ...sysBRows.map((r) => r.rent),
  );

  const PS = {
    current: {
      bd: "#3b82f6",
      badgeBg: "#dbeafe",
      badgeTxt: "#1e40af",
      label: "Congelat",
    },
    frozen: {
      bd: "#f59e0b",
      badgeBg: "#fef3c7",
      badgeTxt: "#92400e",
      label: "Pròrroga",
    },
    lib: {
      bd: "#16a34a",
      badgeBg: "#dcfce7",
      badgeTxt: "#15803d",
      label: "🔓 Alliberat",
    },
    b: {
      bd: "#a855f7",
      badgeBg: "#f3e8ff",
      badgeTxt: "#6b21a8",
      label: "Nou contracte",
    },
    c: {
      bd: "#ea580c",
      badgeBg: "#ffedd5",
      badgeTxt: "#9a3412",
      label: "Nou contracte",
    },
    c45b: {
      bd: "#a855f7",
      badgeBg: "#f3e8ff",
      badgeTxt: "#6b21a8",
      label: "Anys 4-5",
    },
    c45: {
      bd: "#0d9488",
      badgeBg: "#ccfbf1",
      badgeTxt: "#0f766e",
      label: "IPC sol",
    },
  };

  // #8 — noms amigables per als sistemes
  const SYS_B_NAME = "Taula d'increments oficial";
  const SYS_C_NAME = "Aproximació al preu de referència";

  // #8 — taula amb explicació de càlculs
  function YearTable({ rows, title, accent, explanation }) {
    return (
      <div
        className="rounded-2xl overflow-hidden"
        style={{ border: `1.5px solid ${accent}` }}
      >
        <div
          className="px-4 py-3 text-base font-semibold text-white"
          style={{ background: accent }}
        >
          {title}
        </div>
        {explanation && (
          <div
            className="px-4 py-3 text-sm leading-relaxed"
            style={{
              background: accent + "18",
              borderBottom: `1px solid ${accent}44`,
              color: C.text,
            }}
          >
            {explanation}
          </div>
        )}
        <div className="overflow-x-auto">
          <table className="w-full" style={{ fontSize: ".95rem" }}>
            <thead>
              <tr
                style={{
                  background: C.sand,
                  borderBottom: `1px solid ${C.border}`,
                }}
              >
                {["Any", "Lloguer/mes", "€/m²", "% anual", "Detall"].map(
                  (h) => (
                    <th
                      key={h}
                      className="px-3 py-2.5 text-xs font-semibold uppercase tracking-wide text-left"
                      style={{ color: C.muted }}
                    >
                      {h}
                    </th>
                  ),
                )}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={i}
                  style={{
                    borderBottom: `1px solid ${C.border}`,
                    background: i === 0 ? "#fdf8f5" : "white",
                  }}
                >
                  <td
                    className="px-3 py-2.5 font-bold"
                    style={{ color: i === 0 ? accent : C.muted }}
                  >
                    {row.year}
                    {i === 0 && " ▶"}
                  </td>
                  <td
                    className="px-3 py-2.5 font-semibold"
                    style={{ color: C.text }}
                  >
                    {fEur(row.rent)}
                  </td>
                  <td className="px-3 py-2.5" style={{ color: C.muted }}>
                    {(row.rent / m2f).toFixed(2).replace(".", ",")} €/m²
                  </td>
                  {/* #7 — % anual */}
                  <td
                    className="px-3 py-2.5 font-semibold"
                    style={{ color: accent }}
                  >
                    {row.prev != null
                      ? fPct((row.rent - row.prev) / row.prev)
                      : "—"}
                  </td>
                  <td className="px-3 py-2.5 text-xs" style={{ color: C.hint }}>
                    {row.label}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr
                style={{ background: C.sand, borderTop: `2px solid ${accent}` }}
              >
                <td
                  className="px-3 py-2.5 text-sm font-bold"
                  style={{ color: accent }}
                >
                  Any 5
                </td>
                <td
                  className="px-3 py-2.5 font-bold"
                  style={{ color: accent, fontSize: "1.05rem" }}
                >
                  {fEur(rows[rows.length - 1].rent)}
                </td>
                <td className="px-3 py-2.5 text-sm" style={{ color: accent }}>
                  {(rows[rows.length - 1].rent / m2f)
                    .toFixed(2)
                    .replace(".", ",")}{" "}
                  €/m²
                </td>
                <td
                  className="px-3 py-2.5 text-sm font-semibold"
                  style={{ color: accent }}
                >
                  {fPct((rows[rows.length - 1].rent - rentAtLib) / rentAtLib)}{" "}
                  total
                </td>
                <td className="px-3 py-2.5 text-xs" style={{ color: accent }}>
                  vs. entrada al nou contracte
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }

  // Explicació dels càlculs per a cada sistema (#8)
  const sysBExplanation = `S'aplica un increment estructural del ${fPct(structRate).replace("+", "")} cada any, més l'IPC (màx. 2,5%), durant els 5 anys del nou contracte. L'increment del ${fPct(structRate).replace("+", "")} ve determinat per la taula oficial en funció del preu/m² actual.`;

  const sysCExplanation = belowParish
    ? (() => {
        const X = r2(targetRent - rentAtLib);
        const step = r2(X / 3);
        const priceNote =
          yearsUntilLib > 0
            ? `El preu de referència de ${parishName} (${parishPrice2026.toFixed(2).replace(".", ",")}€/m² el 2026) s'ha actualitzat amb l'IPC fins al ${libYear}, resultant en ${parishPrice.toFixed(2).replace(".", ",")}€/m².`
            : `El preu de referència de ${parishName} és ${parishPrice.toFixed(2).replace(".", ",")}€/m² (sense actualització d'IPC, ja que el contracte s'allibera el primer any sense pròrroga).`;
        return `${priceNote} El preu actual del contracte (${priceAtLib.toFixed(2).replace(".", ",")}€/m²) és inferior. La diferència mensual és de ${fEur(X).trim()} (${fEur(targetRent).trim()} − ${fEur(rentAtLib).trim()}). Durant els 3 primers anys s'afegeix 1/3 d'aquesta diferència (${fEur(step).trim()}/mes) + IPC cada any. ${sysCUsesB45 ? `Al 3r any el lloguer de l'aproximació (${fEur(sysCRows[2].rent).trim()}) seria inferior al de la taula oficial (${fEur(sysBRows[2].rent).trim()}), per tant els anys 4 i 5 s'aplica la taula oficial.` : `Al 3r any ja s'ha superat el nivell de la taula oficial, per tant els anys 4 i 5 s'aplica únicament l'IPC.`}`;
      })()
    : "";

  return (
    <div className="min-h-screen" style={{ background: C.cream }}>
      {showInfo && <InfoModal onClose={() => setShowInfo(false)} />}
      {/* Injecta CSS d'impressió */}
      <style>{PRINT_STYLE}</style>

      {/* Capçalera visible només en impressió */}
      <div
        className="print-only"
        style={{
          padding: "0 0 16px",
          borderBottom: "2px solid #97312b",
          marginBottom: 24,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <div>
            <img
              src="/logoPrint.png"
              alt="Fercamp"
              style={{ height: 40, objectFit: "contain", marginBottom: 4 }}
            />
          </div>
          <div style={{ textAlign: "right" }}>
            <div
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              Simulació descongelació lloguers
            </div>
            <div style={{ fontSize: ".8rem", color: "#8a7060" }}>
              {new Date().toLocaleDateString("ca-AD", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 12,
            padding: "8px 12px",
            background: "#fffbeb",
            border: "1px solid #f59e0b",
            borderRadius: 6,
            fontSize: ".75rem",
            color: "#78350f",
          }}
        >
          Simulació basada en la Llei 11/2026 (Govern d'Andorra, 4 juny 2026).
          Abans de prendre cap decisió llegiu el text legal complet. Fercamp no
          es fa responsable d'errors.
        </div>
      </div>

      <NavBar onBack={onBack} onHome={onNewSimulation} />

      {/* HERO RESULTATS */}
      <div
        style={{
          background: `linear-gradient(150deg, ${C.redDark} 0%, ${C.red} 55%, ${C.redLight} 100%)`,
        }}
      >
        <div className="max-w-5xl mx-auto px-4 pt-9 pb-12">
          {/* Navegació superior */}
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={onBack}
              className="flex items-center gap-1.5 text-sm hover:opacity-70 transition-opacity"
              style={{
                color: "rgba(255,255,255,.75)",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
              }}
            >
              ← Editar les dades
            </button>
            <button
              onClick={onNewSimulation}
              className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all hover:brightness-110 active:scale-[.99]"
              style={{
                background: "white",
                color: C.red,
                border: "none",
                cursor: "pointer",
              }}
            >
              + Nova simulació
            </button>
          </div>
          {/* Logo — igual que a la landing */}
          <div className="mb-6">
            <img
              src="/logo.png"
              alt="Fercamp"
              className="h-12 object-contain"
              data-logo="white"
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-6">
            <div className="flex-1">
              <div
                className="text-xs font-bold uppercase tracking-widest mb-2"
                style={{ color: "rgba(255,255,255,.5)" }}
              >
                Simulació · Immobiliaria Andorra · Fercamp
              </div>
              <h1
                className="font-semibold mb-2"
                style={{
                  fontFamily: "Georgia, serif",
                  color: "white",
                  fontSize: "clamp(1.3rem,4vw,2.2rem)",
                  lineHeight: 1.1,
                }}
              >
                {parishName} · {m2f}m² · {fEur(initialRent).trim()}/mes
              </h1>
              <div
                style={{ color: "rgba(255,255,255,.75)", fontSize: ".9rem" }}
              >
                Contracte de l'any {form.contractYear} · IPC{" "}
                {(ipc * 100).toFixed(1).replace(".", ",")}%
                {ipcInput > 2.5 && (
                  <span style={{ color: "rgba(255,255,160,.9)" }}>
                    {" "}
                    (limitat des de {ipcInput}%)
                  </span>
                )}
              </div>
            </div>
            {/* PREU M² EN GRAN */}
            <div className="flex-shrink-0 text-right">
              <div
                className="text-sm uppercase tracking-widest mb-1"
                style={{ color: "rgba(255,255,255,.6)" }}
              >
                Preu per m²
              </div>
              <div
                style={{
                  fontFamily: "Georgia, serif",
                  color: "white",
                  fontSize: "clamp(3rem,9vw,5.5rem)",
                  fontWeight: 700,
                  lineHeight: 0.85,
                }}
              >
                {pricePerM2.toFixed(2).replace(".", ",")}
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  opacity: 0.9,
                }}
              >
                €/m²
              </div>
              <div
                className="mt-3 text-sm"
                style={{ color: "rgba(255,255,255,.85)", lineHeight: 1.6 }}
              >
                <div
                  style={{
                    color: priceAtLib < parishPrice ? "#86efac" : "#fca5a5",
                    fontWeight: 600,
                    marginBottom: 3,
                  }}
                >
                  {priceAtLib < parishPrice
                    ? `▼ Inferior al preu de referència de ${parishName}`
                    : `▲ Superior o igual al preu de referència de ${parishName}`}
                </div>
                <div
                  style={{ color: "rgba(255,255,255,.6)", fontSize: ".8rem" }}
                >
                  Ref. parc públic:{" "}
                  {parishPrice2026.toFixed(2).replace(".", ",")}€/m²
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8 space-y-5">
        {/* Avís provisional prominent — sempre visible */}
        <ProvisionalBanner />

        {/* MÈTRIQUES */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {[
            {
              l: "Any d'alliberament",
              v: String(libYear),
              sub: `${libYear - 2026} anys des d'ara`,
              c: "#16a34a",
            },
            {
              l: "Règim aplicable",
              v: belowParish ? "Dos escenaris" : "Taula oficial",
              sub: belowParish ? "Veure comparació" : "Increment estructural",
              c: C.red,
            },
            {
              l: `Lloguer any ${libYear + 4}`,
              v: fEur(sysBRows[4].rent).trim(),
              sub: "Any 5 taula oficial",
              c: C.text,
            },
            {
              l: "Increment total (any 5)",
              v: `+${(((sysBRows[4].rent - rentAtLib) / rentAtLib) * 100).toFixed(1).replace(".", ",")}%`,
              sub: `${fEur(rentAtLib).trim()} → ${fEur(sysBRows[4].rent).trim()}`,
              c: "#7c3aed",
            },
          ].map((m, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-4"
              style={{ border: `1px solid ${C.border}` }}
            >
              <div
                className="text-xs uppercase tracking-wider mb-2"
                style={{ color: C.hint }}
              >
                {m.l}
              </div>
              <div
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "1.5rem",
                  color: m.c,
                  fontWeight: 600,
                  lineHeight: 1.1,
                }}
              >
                {m.v}
              </div>
              <div className="text-sm mt-1" style={{ color: C.hint }}>
                {m.sub}
              </div>
            </div>
          ))}
        </div>

        {/* ANY D'ALLIBERAMENT */}
        <div
          className="bg-white rounded-3xl p-5 sm:p-7"
          style={{ border: "2px solid #16a34a" }}
        >
          <div
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-bold mb-3"
            style={{ background: "#dcfce7", color: "#15803d" }}
          >
            🔓 Any d'alliberament
          </div>
          <h3
            className="font-semibold mb-2"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "1.4rem",
              color: C.text,
            }}
          >
            Alliberat l'any <span style={{ color: "#16a34a" }}>{libYear}</span>
          </h3>
          <p
            className="leading-relaxed"
            style={{ color: C.muted, fontSize: "1rem" }}
          >
            {frozenCount === 0
              ? `El primer increment s'aplica directament el ${libYear}. No hi ha anys addicionals de pròrroga.`
              : `Fins al ${libYear - 1} el lloguer s'actualitzarà amb IPC. A partir del ${libYear} s'activa el nou contracte de 5 anys.`}
          </p>
        </div>

        {/* PRÒRROGA */}
        {frozenRows.length > 1 && (
          <div
            className="bg-white rounded-3xl p-5 sm:p-7"
            style={{ border: `1px solid ${C.border}` }}
          >
            <h3
              className="font-semibold mb-1"
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "1.2rem",
                color: C.text,
              }}
            >
              📅 Pròrroga fins l'alliberament (2026 → {libYear - 1})
            </h3>
            <p
              className="mb-4 text-sm leading-relaxed"
              style={{ color: C.muted }}
            >
              Durant aquest període el lloguer{" "}
              <strong style={{ color: C.text }}>
                només es pot actualitzar amb l'IPC
              </strong>
              . No s'aplica cap increment addicional — la pujada és únicament
              per l'IPC. En aquest cas, l'IPC és el que s'ha introduït al
              formulari.
            </p>
            <div className="overflow-x-auto">
              <table className="w-full" style={{ fontSize: ".95rem" }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${C.border}` }}>
                    {["Any", "Lloguer/mes", "€/m²", "% anual", "Situació"].map(
                      (h) => (
                        <th
                          key={h}
                          className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-left"
                          style={{ color: C.muted }}
                        >
                          {h}
                        </th>
                      ),
                    )}
                  </tr>
                </thead>
                <tbody>
                  {frozenRows.map((row, i) => {
                    const ps = PS[row.phase] || PS.frozen;
                    const prev = i > 0 ? frozenRows[i - 1].rent : null;
                    return (
                      <tr
                        key={i}
                        style={{
                          borderBottom: `1px solid ${C.border}`,
                          background:
                            row.phase === "current" ? "#eff6ff" : "white",
                        }}
                      >
                        <td
                          className="px-3 py-2.5 font-bold"
                          style={{
                            color:
                              row.phase === "current" ? "#1d4ed8" : C.muted,
                          }}
                        >
                          {row.year}
                        </td>
                        <td
                          className="px-3 py-2.5 font-semibold"
                          style={{ color: C.text }}
                        >
                          {fEur(row.rent)}
                        </td>
                        <td className="px-3 py-2.5" style={{ color: C.muted }}>
                          {(row.rent / m2f).toFixed(2).replace(".", ",")} €/m²
                        </td>
                        {/* #7 — % anual */}
                        <td
                          className="px-3 py-2.5 font-semibold"
                          style={{ color: "#f59e0b" }}
                        >
                          {prev ? fPct((row.rent - prev) / prev) : "—"}
                        </td>
                        <td className="px-3 py-2.5">
                          <span
                            className="text-xs px-2 py-0.5 rounded-full font-medium"
                            style={{
                              background: ps.badgeBg,
                              color: ps.badgeTxt,
                            }}
                          >
                            {ps.label}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* SISTEMES — #8 noms amigables, #6 to neutral per a llogaters */}
        {belowParish ? (
          <div className="space-y-4">
            <div
              className="bg-white rounded-3xl p-5 sm:p-7"
              style={{ border: `1px solid ${C.border}` }}
            >
              <h3
                className="font-semibold mb-2"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "1.3rem",
                  color: C.text,
                }}
              >
                Possibles escenaris un cop alliberat el contracte
              </h3>
              {/* #6 — explicació neutral, enfocada en el llogater */}
              <p
                className="leading-relaxed mb-5"
                style={{ color: C.muted, fontSize: "1rem" }}
              >
                El teu preu actual (
                <strong>{priceAtLib.toFixed(2).replace(".", ",")}€/m²</strong>)
                és inferior al preu de referència del parc públic de{" "}
                <strong>{parishName}</strong> actualitzat al {libYear} (
                <strong>{parishPrice.toFixed(2).replace(".", ",")}€/m²</strong>
                {yearsUntilLib > 0 && (
                  <span style={{ color: C.hint, fontSize: ".9rem" }}>
                    , partint de {parishPrice2026.toFixed(2).replace(".", ",")}
                    €/m² el 2026 + {yearsUntilLib} any
                    {yearsUntilLib > 1 ? "s" : ""} d'IPC
                  </span>
                )}
                ). Quan el contracte s'alliberi, el propietari pot triar entre
                dos enfocaments. A continuació veus els dos escenaris.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div
                  className="p-5 rounded-2xl"
                  style={{
                    background: "#faf5ff",
                    border: "1.5px solid #a855f7",
                  }}
                >
                  <div
                    className="font-bold mb-1"
                    style={{ color: "#7c3aed", fontSize: "1rem" }}
                  >
                    {SYS_B_NAME}
                  </div>
                  <div
                    className="leading-relaxed mb-3"
                    style={{ color: "#6b21a8", fontSize: ".9rem" }}
                  >
                    Aplica directament la taula oficial:{" "}
                    {fPct(structRate).replace("+", "")} estructural + IPC cada
                    any durant 5 anys.
                  </div>
                  <div
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "1.8rem",
                      color: "#7c3aed",
                      fontWeight: 600,
                    }}
                  >
                    {fEur(sysBRows[4].rent).trim()}
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        color: "#a855f7",
                      }}
                    >
                      {" "}
                      /mes · any 5
                    </span>
                  </div>
                </div>
                <div
                  className="p-5 rounded-2xl"
                  style={{
                    background: "#fff7ed",
                    border: "1.5px solid #ea580c",
                  }}
                >
                  <div
                    className="font-bold mb-1"
                    style={{ color: "#c2410c", fontSize: "1rem" }}
                  >
                    {SYS_C_NAME}
                  </div>
                  <div
                    className="leading-relaxed mb-3"
                    style={{ color: "#9a3412", fontSize: ".9rem" }}
                  >
                    En 3 anys s'arriba gradualment al preu de referència (
                    {fEur(targetRent).trim()}/mes).
                    {sysCUsesB45
                      ? " Els anys 4-5 s'aplica la taula oficial."
                      : " Els anys 4-5 s'aplica únicament l'IPC."}
                  </div>
                  <div
                    style={{
                      fontFamily: "Georgia, serif",
                      fontSize: "1.8rem",
                      color: "#c2410c",
                      fontWeight: 600,
                    }}
                  >
                    {fEur(sysCRows[4].rent).trim()}
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: 400,
                        color: "#ea580c",
                      }}
                    >
                      {" "}
                      /mes · any 5
                    </span>
                  </div>
                </div>
              </div>
              {/* #6 — missatge neutral, no "qui guanya" */}
              <div
                className="p-4 rounded-xl text-sm leading-relaxed"
                style={{
                  background: C.sand,
                  border: `1px solid ${C.border}`,
                  color: C.muted,
                }}
              >
                <strong style={{ color: C.text }}>
                  ℹ️ Com interpretar els dos escenaris:
                </strong>{" "}
                El primer mostra la pujada si s'aplica directament la taula
                oficial. El segon mostra l'aproximació gradual al preu de
                referència de la parròquia. En ambdós casos, el lloguer del 5è
                any seria de{" "}
                <strong style={{ color: C.text }}>
                  {fEur(Math.min(sysBRows[4].rent, sysCRows[4].rent)).trim()}
                </strong>{" "}
                a{" "}
                <strong style={{ color: C.text }}>
                  {fEur(Math.max(sysBRows[4].rent, sysCRows[4].rent)).trim()}
                </strong>
                .
              </div>

              {/* Taula de referència plegable */}
              <details className="group" style={{ marginTop: 12 }}>
                <summary
                  className="flex items-center gap-2 text-sm font-semibold cursor-pointer select-none list-none"
                  style={{ color: C.red }}
                >
                  <span className="group-open:hidden">▶</span>
                  <span className="hidden group-open:inline">▼</span>
                  Consultar taula completa d'increments
                </summary>
                <div
                  className="mt-3 rounded-2xl overflow-hidden"
                  style={{ border: `1px solid ${C.border}` }}
                >
                  <div className="px-4 py-2" style={{ background: C.red }}>
                    <div
                      style={{
                        color: "white",
                        fontSize: ".85rem",
                        fontWeight: 600,
                      }}
                    >
                      Taula oficial d'increments anuals (5 anys)
                    </div>
                    <div
                      style={{
                        color: "rgba(255,255,255,.5)",
                        fontSize: ".65rem",
                      }}
                    >
                      Font: Llei 11/2026 · Govern d'Andorra · 4 juny 2026
                    </div>
                  </div>
                  <table className="w-full" style={{ fontSize: ".9rem" }}>
                    <tbody>
                      {[
                        ["≤ 7 €/m²", "6% + IPC"],
                        ["> 7 i ≤ 8 €/m²", "5% + IPC"],
                        ["> 8 i ≤ 9 €/m²", "4% + IPC"],
                        ["> 9 i ≤ 10 €/m²", "3% + IPC"],
                        ["> 10 i ≤ 12 €/m²", "2% + IPC"],
                        ["> 12 €/m²", "1% + IPC"],
                      ].map(([range, inc], i) => {
                        const isMyRow =
                          (priceAtLib <= 7 && i === 0) ||
                          (priceAtLib > 7 && priceAtLib <= 8 && i === 1) ||
                          (priceAtLib > 8 && priceAtLib <= 9 && i === 2) ||
                          (priceAtLib > 9 && priceAtLib <= 10 && i === 3) ||
                          (priceAtLib > 10 && priceAtLib <= 12 && i === 4) ||
                          (priceAtLib > 12 && i === 5);
                        return (
                          <tr
                            key={i}
                            style={{
                              borderBottom:
                                i < 5 ? `1px solid ${C.border}` : "none",
                              background: i % 2 === 0 ? "white" : C.cream,
                              fontWeight: isMyRow ? 700 : 400,
                            }}
                          >
                            <td className="px-4 py-2" style={{ color: C.text }}>
                              {range}
                              {isMyRow && (
                                <span
                                  className="ml-2 px-1.5 py-0.5 rounded text-xs"
                                  style={{
                                    background: C.red,
                                    color: "white",
                                    fontWeight: 700,
                                  }}
                                >
                                  ← tu
                                </span>
                              )}
                            </td>
                            <td
                              className="px-4 py-2 text-right font-semibold"
                              style={{ color: C.red }}
                            >
                              {inc}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </details>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <YearTable
                rows={sysBRows}
                title={SYS_B_NAME}
                accent="#a855f7"
                explanation={sysBExplanation}
              />
              <YearTable
                rows={sysCRows}
                title={SYS_C_NAME}
                accent="#ea580c"
                explanation={sysCExplanation}
              />
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div
              className="bg-white rounded-3xl p-5 sm:p-7"
              style={{ border: `1px solid ${C.border}` }}
            >
              <h3
                className="font-semibold mb-2"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "1.3rem",
                  color: C.text,
                }}
              >
                Escenari del nou contracte: {SYS_B_NAME}
              </h3>
              <p
                className="leading-relaxed mb-4"
                style={{ color: C.muted, fontSize: "1rem" }}
              >
                El teu preu/m² ({priceAtLib.toFixed(2).replace(".", ",")}€/m²)
                és igual o superior al preu de referència de {parishName}{" "}
                actualitzat al {libYear}(
                {parishPrice.toFixed(2).replace(".", ",")}€/m²). S'aplica
                directament la taula oficial:{" "}
                <strong>
                  {fPct(structRate).replace("+", "")} estructural + IPC
                </strong>{" "}
                durant els 5 anys del nou contracte.
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                {[
                  {
                    l: "Increment estructural/any",
                    v: fPct(structRate),
                    c: "#7c3aed",
                    b: "#f3e8ff",
                  },
                  {
                    l: "IPC màxim/any",
                    v: fPct(ipc),
                    c: "#c2410c",
                    b: "#ffedd5",
                  },
                  {
                    l: "Total/any",
                    v: fPct(structRate + ipc),
                    c: "#15803d",
                    b: "#dcfce7",
                  },
                ].map((t, i) => (
                  <div
                    key={i}
                    className="px-4 py-2 rounded-xl text-sm font-medium"
                    style={{ background: t.b, color: t.c }}
                  >
                    {t.l}: <strong>{t.v}</strong>
                  </div>
                ))}
              </div>

              {/* Taula de referència completa */}
              <details className="group">
                <summary
                  className="flex items-center gap-2 text-sm font-semibold cursor-pointer select-none list-none"
                  style={{ color: C.red }}
                >
                  <span className="group-open:hidden">▶</span>
                  <span className="hidden group-open:inline">▼</span>
                  Consultar taula completa d'increments
                </summary>
                <div
                  className="mt-3 rounded-2xl overflow-hidden"
                  style={{ border: `1px solid ${C.border}` }}
                >
                  <div className="px-4 py-2" style={{ background: C.red }}>
                    <div
                      style={{
                        color: "white",
                        fontSize: ".85rem",
                        fontWeight: 600,
                      }}
                    >
                      Taula oficial d'increments anuals (5 anys)
                    </div>
                    <div
                      style={{
                        color: "rgba(255,255,255,.5)",
                        fontSize: ".65rem",
                      }}
                    >
                      Font: Llei 11/2026 · Govern d'Andorra · 4 juny 2026
                    </div>
                  </div>
                  <table className="w-full" style={{ fontSize: ".9rem" }}>
                    <tbody>
                      {[
                        ["≤ 7 €/m²", "6% + IPC"],
                        ["> 7 i ≤ 8 €/m²", "5% + IPC"],
                        ["> 8 i ≤ 9 €/m²", "4% + IPC"],
                        ["> 9 i ≤ 10 €/m²", "3% + IPC"],
                        ["> 10 i ≤ 12 €/m²", "2% + IPC"],
                        ["> 12 €/m²", "1% + IPC"],
                      ].map(([range, inc], i) => (
                        <tr
                          key={i}
                          style={{
                            borderBottom:
                              i < 5 ? `1px solid ${C.border}` : "none",
                            background: i % 2 === 0 ? "white" : C.cream,
                            fontWeight:
                              (priceAtLib <= 7 && i === 0) ||
                              (priceAtLib > 7 && priceAtLib <= 8 && i === 1) ||
                              (priceAtLib > 8 && priceAtLib <= 9 && i === 2) ||
                              (priceAtLib > 9 && priceAtLib <= 10 && i === 3) ||
                              (priceAtLib > 10 &&
                                priceAtLib <= 12 &&
                                i === 4) ||
                              (priceAtLib > 12 && i === 5)
                                ? 700
                                : 400,
                          }}
                        >
                          <td className="px-4 py-2" style={{ color: C.text }}>
                            {range}
                            {((priceAtLib <= 7 && i === 0) ||
                              (priceAtLib > 7 && priceAtLib <= 8 && i === 1) ||
                              (priceAtLib > 8 && priceAtLib <= 9 && i === 2) ||
                              (priceAtLib > 9 && priceAtLib <= 10 && i === 3) ||
                              (priceAtLib > 10 &&
                                priceAtLib <= 12 &&
                                i === 4) ||
                              (priceAtLib > 12 && i === 5)) && (
                              <span
                                className="ml-2 px-1.5 py-0.5 rounded text-xs"
                                style={{
                                  background: C.red,
                                  color: "white",
                                  fontWeight: 700,
                                }}
                              >
                                ← tu
                              </span>
                            )}
                          </td>
                          <td
                            className="px-4 py-2 text-right font-semibold"
                            style={{ color: C.red }}
                          >
                            {inc}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            </div>
            <YearTable
              rows={sysBRows}
              title={`${SYS_B_NAME} — Evolució any a any`}
              accent="#a855f7"
              explanation={sysBExplanation}
            />
          </div>
        )}

        {/* GRÀFIC amb % anual — tabs si hi han 2 escenaris */}
        <div
          className="bg-white rounded-3xl p-5 sm:p-7"
          style={{ border: `1px solid ${C.border}` }}
        >
          <h3
            className="font-semibold mb-4"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "1.2rem",
              color: C.text,
            }}
          >
            Evolució visual del lloguer
          </h3>

          {belowParish ? (
            <ChartTabs
              frozenRows={frozenRows}
              sysBRows={sysBRows}
              sysCRows={sysCRows}
              initialRent={initialRent}
              maxRent={Math.max(
                ...frozenRows.map((r) => r.rent),
                ...sysBRows.map((r) => r.rent),
                ...sysCRows.map((r) => r.rent),
              )}
              PS={PS}
              fEur={fEur}
              fPct={fPct}
              C={C}
            />
          ) : (
            <>
              <BarChart
                rows={[...frozenRows, ...sysBRows]}
                initialRent={initialRent}
                maxRent={maxRent}
                PS={PS}
                fEur={fEur}
                C={C}
              />
              <div className="mt-4 flex flex-wrap gap-3 text-sm">
                {[
                  { c: "#3b82f6", l: "Congelat" },
                  { c: "#f59e0b", l: "Pròrroga" },
                  { c: "#16a34a", l: "Alliberat" },
                  { c: "#a855f7", l: "Nou contracte" },
                ].map((x, i) => (
                  <div key={i} className="flex items-center gap-1.5">
                    <div
                      className="w-3 h-3 rounded-sm flex-shrink-0"
                      style={{ background: x.c }}
                    />
                    <span style={{ color: C.muted }}>{x.l}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* COMPARTIR + ACCIONS */}
        <div
          className="bg-white rounded-3xl p-5 sm:p-7 no-print"
          style={{ border: `1px solid ${C.border}` }}
        >
          <h3
            className="font-semibold mb-2"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "1.2rem",
              color: C.text,
            }}
          >
            Compartir i guardar
          </h3>
          <p className="mb-4" style={{ color: C.muted, fontSize: "1rem" }}>
            Copia el link per enviar aquesta simulació, o imprimeix-la per
            guardar-la en paper o PDF.
          </p>
          <div className="flex gap-3 flex-wrap">
            <button
              onClick={handleShare}
              className="flex items-center gap-2 px-5 py-3 rounded-xl font-semibold text-base text-white transition-all hover:brightness-110 active:scale-[.99]"
              style={{ background: C.red, border: "none", cursor: "pointer" }}
            >
              🔗 {copied ? "✓ Copiat!" : "Copiar link"}
            </button>
            <button
              onClick={() => window.print()}
              className="flex items-center gap-2 px-5 py-3 rounded-xl font-semibold text-base transition-all hover:brightness-110 active:scale-[.99]"
              style={{
                background: C.text,
                color: "white",
                border: "none",
                cursor: "pointer",
              }}
            >
              🖨️ Imprimir / Guardar PDF
            </button>
            <button
              onClick={onBack}
              className="flex items-center gap-2 px-5 py-3 rounded-xl font-semibold text-base transition-all"
              style={{
                background: C.sand,
                color: C.red,
                border: `1px solid ${C.border}`,
                cursor: "pointer",
              }}
            >
              ← Editar les dades
            </button>
            <button
              onClick={onNewSimulation}
              className="flex items-center gap-2 px-5 py-3 rounded-xl font-semibold text-base transition-all"
              style={{
                background: "white",
                color: C.muted,
                border: `1px solid ${C.border}`,
                cursor: "pointer",
              }}
            >
              Nova simulació
            </button>
          </div>
        </div>

        {/* CANVI 2 — Card "Fes una altra simulació" — no a la impressió */}
        <div
          className="bg-white rounded-3xl p-5 sm:p-7 no-print"
          style={{ border: `1px solid ${C.border}` }}
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div>
              <h3
                className="font-semibold mb-1"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "1.15rem",
                  color: C.text,
                }}
              >
                Vols simular un altre contracte?
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: C.muted }}>
                Aquesta eina calcula l'impacte de la descongelació en qualsevol
                contracte d'arrendament d'Andorra. Introdueix les dades de cada
                contracte per veure quan s'allibera i com evoluciona la renda.
              </p>
            </div>
            <button
              onClick={onNewSimulation}
              className="flex-shrink-0 flex items-center gap-2 px-6 py-3 rounded-2xl font-semibold text-sm transition-all hover:brightness-110 active:scale-[.99]"
              style={{
                background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
                color: "white",
                border: "none",
                cursor: "pointer",
                boxShadow: `0 4px 14px ${C.red}44`,
              }}
            >
              + Nova simulació
            </button>
          </div>
        </div>

        <div className="no-print">
          <MortgageBanner />
        </div>

        <div className="no-print">
          <InstagramBanner />
        </div>

        {/* Card "En base a que s'ha calculat" */}
        <div
          className="bg-white rounded-3xl p-5 sm:p-7 no-print"
          style={{ border: `1px solid ${C.border}` }}
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div>
              <h3
                className="font-semibold mb-1"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "1.1rem",
                  color: C.text,
                }}
              >
                📋 En base a què s'ha calculat tot això?
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: C.muted }}>
                Aquesta simulació es basa en la Llei 11/2026, del 4 de juny,
                d'aprovació del règim jurídic aplicable als contractes
                d'arrendament d'habitatge per a residència habitual i permanent
                per al període 2027–2030. Consulta les claus de la llei, els
                trams d'alliberament i la taula oficial d'increments.
              </p>
            </div>
            <button
              onClick={() => setShowInfo(true)}
              className="flex-shrink-0 flex items-center gap-2 px-5 py-3 rounded-2xl font-semibold text-sm transition-all hover:brightness-110 active:scale-[.99]"
              style={{
                background: C.sand,
                color: C.text,
                border: `1px solid ${C.border}`,
                cursor: "pointer",
              }}
            >
              Llegir les claus →
            </button>
          </div>
        </div>

        {/* CTA final — propietaris */}
        <div
          className="rounded-3xl overflow-hidden no-print"
          style={{
            background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
          }}
        >
          <div className="px-6 sm:px-10 py-9 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
            <div>
              <div
                className="text-xs font-bold uppercase tracking-widest mb-2"
                style={{ color: "rgba(255,255,255,.5)" }}
              >
                Immobiliaria Andorra · Fercamp
              </div>
              <h3
                className="mb-2 font-semibold"
                style={{
                  fontFamily: "Georgia, serif",
                  color: "white",
                  fontSize: "1.4rem",
                }}
              >
                Tens dubtes? T'assessorem sense compromís
              </h3>
              <p
                className="leading-relaxed"
                style={{ color: "rgba(255,255,255,.85)", fontSize: ".95rem" }}
              >
                Som especialistes en el mercat de lloguer d'Andorra. T'ajudem a
                entendre la llei, tant si ets propietari com llogater.
              </p>
            </div>
            <div className="flex flex-col gap-2 flex-shrink-0">
              {onOpenBanner ? (
                <button
                  onClick={onOpenBanner}
                  className="px-6 py-3 rounded-2xl text-sm font-semibold text-center hover:opacity-90 transition-opacity"
                  style={{
                    background: "white",
                    color: C.red,
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Contacta'ns →
                </button>
              ) : (
                <a
                  href={`mailto:${EMAIL}?subject=Assessoria descongelació lloguers`}
                  className="px-6 py-3 rounded-2xl text-sm font-semibold text-center hover:opacity-90"
                  style={{
                    background: "white",
                    color: C.red,
                    textDecoration: "none",
                  }}
                >
                  Contacta'ns →
                </a>
              )}
              <a
                href="https://simulador-fercamp.web.app"
                target="_blank"
                rel="noopener"
                className="px-6 py-3 rounded-2xl text-sm font-semibold text-center"
                style={{
                  background: "rgba(255,255,255,.15)",
                  color: "white",
                  textDecoration: "none",
                  border: "1px solid rgba(255,255,255,.25)",
                }}
              >
                🏠 Simula una hipoteca
              </a>
            </div>
          </div>
        </div>

        <Disclaimer />
      </div>
    </div>
  );
}

// ─── CODE BANNER COMPONENT ───────────────────────────────────
function CodeBanner({ onSuccess, onClose }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  async function handleActivate() {
    const trimmed = code.trim().toUpperCase();
    if (!trimmed) {
      setError("Introdueix un codi");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const { db } = await import("./firebase");
      const { doc, getDoc, updateDoc, increment } =
        await import("firebase/firestore");
      const ref = doc(db, "codes", trimmed);
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        setError("Codi no vàlid. Comprova que l'has escrit bé.");
        return;
      }
      const data = snap.data();
      if (data.disabled) {
        setError("Aquest codi ha estat desactivat. Contacta'ns.");
        return;
      }
      if (data.active) {
        setError(
          "Aquest codi ja ha estat activat i no es pot tornar a utilitzar.",
        );
        return;
      }
      if (data.count >= data.max_count) {
        setError("Aquest codi ha exhaurit les simulacions disponibles.");
        return;
      }
      if (data.expires_at && data.expires_at.toDate() < new Date()) {
        setError("Aquest codi ha caducat. Contacta'ns per renovar-lo.");
        return;
      }
      // Activar: incrementem count i posem active=true
      await updateDoc(ref, { active: true, count: increment(1) });
      const newCount = data.count + 1;
      localStorage.setItem(CODE_LS_KEY, trimmed);
      localStorage.setItem(CODE_COUNT_KEY, String(newCount));
      localStorage.setItem(CODE_MAX_KEY, String(data.max_count));
      onSuccess({ count: newCount, max: data.max_count });
    } catch (e) {
      console.error("Firebase error:", e);
      setError("Error de connexió. Torna-ho a provar.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
      style={{ background: "rgba(8,12,24,0.72)" }}
    >
      <div
        className="w-full sm:max-w-sm bg-white shadow-2xl flex flex-col"
        style={{ borderRadius: "20px 20px 0 0", overflow: "hidden" }}
      >
        {/* Capçalera */}
        <div
          className="px-6 pt-6 pb-5 relative"
          style={{
            background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
          }}
        >
          <button
            onClick={onClose}
            className="absolute top-3 right-4 flex items-center justify-center w-7 h-7 rounded-full"
            style={{
              background: "rgba(255,255,255,.2)",
              border: "none",
              cursor: "pointer",
              color: "white",
              fontSize: ".9rem",
            }}
          >
            ✕
          </button>
          <img
            src="/logo.png"
            alt="Fercamp"
            className="h-7 object-contain mb-3"
            data-logo="white"
          />
          <h2
            style={{
              fontFamily: "Georgia, serif",
              color: "white",
              fontSize: "1.15rem",
              fontWeight: 700,
              lineHeight: 1.25,
              margin: 0,
            }}
          >
            Introdueix el teu codi d'accés
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,.75)",
              fontSize: ".8rem",
              margin: "6px 0 0",
            }}
          >
            Si tens un codi proporcionat per Fercamp, introdueix-lo aquí per
            continuar.
          </p>
        </div>

        {/* Cos */}
        <div className="px-6 py-6 space-y-4">
          <div>
            <input
              type="text"
              value={code}
              onChange={(e) => {
                setCode(e.target.value.toUpperCase());
                setError("");
              }}
              onKeyDown={(e) => e.key === "Enter" && handleActivate()}
              placeholder="Ex: ABC12345"
              maxLength={20}
              className="w-full px-4 py-3 rounded-xl border text-center text-lg font-mono font-bold tracking-widest transition-all focus:outline-none focus:ring-2 focus:ring-red-700/30"
              style={{
                border: `2px solid ${error ? "#f87171" : C.border}`,
                background: error ? "#fff5f5" : "white",
                color: C.text,
                letterSpacing: "0.15em",
              }}
              autoFocus
              autoCapitalize="characters"
              spellCheck={false}
            />
            {error && (
              <p className="text-red-500 text-sm mt-1.5 text-center">{error}</p>
            )}
          </div>

          <button
            onClick={handleActivate}
            disabled={loading || !code.trim()}
            className="w-full py-3.5 rounded-2xl text-white font-bold text-base transition-all hover:brightness-110 active:scale-[.99] disabled:opacity-50"
            style={{
              background: `linear-gradient(135deg, ${C.redDark} 0%, ${C.red} 100%)`,
              border: "none",
              cursor: loading || !code.trim() ? "not-allowed" : "pointer",
              boxShadow: `0 4px 14px ${C.red}44`,
            }}
          >
            {loading ? "Verificant…" : "Activar codi →"}
          </button>

          {/* Divisor */}
          <div className="flex items-center gap-3">
            <div style={{ flex: 1, height: 1, background: C.border }} />
            <span className="text-xs" style={{ color: C.hint }}>
              o bé
            </span>
            <div style={{ flex: 1, height: 1, background: C.border }} />
          </div>

          {/* Contacte */}
          <div className="space-y-2">
            <a
              href="tel:+376738721"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl font-semibold text-sm transition-all hover:brightness-95"
              style={{
                background: C.sand,
                color: C.text,
                border: `1px solid ${C.border}`,
                textDecoration: "none",
              }}
            >
              📞 Contacta'ns · 738 721
            </a>
            <a
              href={WA_URL}
              target="_blank"
              rel="noopener"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl font-semibold text-sm text-white transition-all hover:brightness-110"
              style={{ background: "#25d366", textDecoration: "none" }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp · +376 374 133
            </a>
          </div>

          <p className="text-xs text-center" style={{ color: C.hint }}>
            No tens codi? Contacta'ns i t'en proporcionem un.
          </p>
        </div>
      </div>
    </div>
  );
}

// ─── APP ──────────────────────────────────────────────────────
export default function App() {
  const urlVals = parseParams();

  // ── Lead banner ──────────────────────────────────────────────
  const [bannerDone, setBannerDone] = useState(
    !BANNER_ACTIVE || localStorage.getItem(LS_KEY) === "true",
  );
  const [showBanner, setShowBanner] = useState(false);

  // ── Comptador de simulacions lliures (localStorage) ──────────
  const [simCount, setSimCount] = useState(() =>
    parseInt(localStorage.getItem(SIM_COUNT_KEY) || "0", 10),
  );
  const limitReached = simCount >= MAX_SIMULATIONS;

  // ── Sistema de codis ─────────────────────────────────────────
  const [hasCode, setHasCode] = useState(
    () => !!localStorage.getItem(CODE_LS_KEY),
  );
  const [codeCount, setCodeCount] = useState(() =>
    parseInt(localStorage.getItem(CODE_COUNT_KEY) || "0", 10),
  );
  const [codeMax, setCodeMax] = useState(() =>
    parseInt(localStorage.getItem(CODE_MAX_KEY) || "0", 10),
  );
  const codeExhausted = hasCode && codeMax > 0 && codeCount >= codeMax;
  const [showCodeBanner, setShowCodeBanner] = useState(false);

  // ── Bloqueig efectiu ─────────────────────────────────────────
  // Bloqueja si: (límit gratuït assolit i sense codi) O (codi exhaurit)
  const isBlocked = (limitReached && !hasCode) || codeExhausted;

  // pendingForm: formulari que espera mentre el banner és obert
  const [pendingForm, setPendingForm] = useState(null);

  // ── Formulari i pàgina ───────────────────────────────────────
  const [form, setForm] = useState(
    urlVals || { contractYear: "", m2: "", parish: "", rent: "", ipc: "2.5" },
  );
  const initResult = urlVals ? simulate(urlVals) : null;
  const [page, setPage] = useState(initResult ? "results" : "form");
  const [result, setResult] = useState(initResult);

  // ── Sync codi a Firebase (fire-and-forget) ───────────────────
  async function syncCodeCount(newLocalCount) {
    try {
      const code = localStorage.getItem(CODE_LS_KEY);
      if (!code) return;
      const { db } = await import("./firebase");
      const { doc, updateDoc, increment } = await import("firebase/firestore");
      await updateDoc(doc(db, "codes", code), { count: increment(1) });
    } catch (e) {
      console.warn("Sync Firebase (no bloquejant):", e);
    }
  }

  // ── Validació final quan queda 1 simulació (count = max - 1) ──
  async function checkCodeBeforeLastSim() {
    try {
      const code = localStorage.getItem(CODE_LS_KEY);
      if (!code) return true;
      const { db } = await import("./firebase");
      const { doc, getDoc } = await import("firebase/firestore");
      const snap = await getDoc(doc(db, "codes", code));
      if (!snap.exists()) return false;
      const data = snap.data();
      if (data.disabled || data.count >= data.max_count) return false;
      return true;
    } catch (e) {
      return true; // en cas d'error de xarxa, deixa passar
    }
  }

  async function doCalculate(formData) {
    // Si té codi: comprovació final quan queda 1 simulació
    if (hasCode) {
      const localCount = codeCount;
      const localMax = codeMax;
      const isLastSim = localCount === localMax - 1;
      if (isLastSim) {
        const ok = await checkCodeBeforeLastSim();
        if (!ok) {
          // El codi s'ha exhaurit o deshabilitat
          setShowCodeBanner(false);
          setShowBanner(true);
          return;
        }
      }
      const newCount = localCount + 1;
      setCodeCount(newCount);
      localStorage.setItem(CODE_COUNT_KEY, String(newCount));
      syncCodeCount(newCount); // fire-and-forget
    } else {
      const newCount = simCount + 1;
      setSimCount(newCount);
      localStorage.setItem(SIM_COUNT_KEY, String(newCount));
    }

    const p = new URLSearchParams({
      y: formData.contractYear,
      m: formData.m2,
      p: formData.parish,
      r: formData.rent,
      i: formData.ipc,
    });
    window.history.replaceState({}, "", "?" + p.toString());
    setResult(simulate(formData));
    setPage("results");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function handleSubmit(formData) {
    if (isBlocked && LOCK_SIMULATION) {
      setPendingForm(formData);
      if (codeExhausted) {
        // Codi exhaurit: mostra el banner de límit directament
        setShowBanner(true);
      } else {
        // Límit gratuït: mostra el lead banner
        setShowBanner(true);
      }
      return;
    }
    doCalculate(formData);
  }

  function handleBannerDone() {
    setBannerDone(true);
    setShowBanner(false);
    localStorage.setItem(SIM_COUNT_KEY, "0");
    setSimCount(0);
    if (pendingForm) {
      doCalculate(pendingForm);
      setPendingForm(null);
    }
  }

  function handleBannerClose() {
    setShowBanner(false);
    if (!LOCK_SIMULATION && pendingForm) {
      doCalculate(pendingForm);
      setPendingForm(null);
    } else {
      setPendingForm(null);
    }
  }

  function handleEnterCode() {
    setShowBanner(false);
    setShowCodeBanner(true);
  }

  function handleCodeSuccess({ count, max }) {
    setHasCode(true);
    setCodeCount(count);
    setCodeMax(max);
    setShowCodeBanner(false);
    // Simula si hi havia un formulari pendent
    if (pendingForm) {
      doCalculate(pendingForm);
      setPendingForm(null);
    }
  }

  function handleBack() {
    setPage("form");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function handleNewSimulation() {
    setForm({ contractYear: "", m2: "", parish: "", rent: "", ipc: "2.5" });
    setResult(null);
    setPage("form");
    window.history.replaceState({}, "", window.location.pathname);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const showBannerTrigger =
    BANNER_ACTIVE && !bannerDone ? () => setShowBanner(true) : null;

  return (
    <>
      {page === "form" ? (
        <FormPage
          onSubmit={handleSubmit}
          form={form}
          setForm={setForm}
          onOpenBanner={showBannerTrigger}
          limitReached={isBlocked && LOCK_SIMULATION}
        />
      ) : (
        <ResultsPage
          result={result}
          form={form}
          onBack={handleBack}
          onNewSimulation={handleNewSimulation}
          onOpenBanner={showBannerTrigger}
        />
      )}
      {showBanner && (
        <LeadBanner
          onDone={handleBannerDone}
          onClose={handleBannerClose}
          isLimit={isBlocked && LOCK_SIMULATION}
          onEnterCode={handleEnterCode}
        />
      )}
      {showCodeBanner && (
        <CodeBanner
          onSuccess={handleCodeSuccess}
          onClose={() => {
            setShowCodeBanner(false);
            if (!LOCK_SIMULATION && pendingForm) {
              doCalculate(pendingForm);
              setPendingForm(null);
            } else {
              setPendingForm(null);
            }
          }}
        />
      )}
      {/* Botó flotant WhatsApp */}
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener"
        className="no-print fixed bottom-5 right-5 z-40 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all hover:scale-110 active:scale-95"
        style={{ background: "#25d366", textDecoration: "none" }}
        title="Contacta'ns per WhatsApp"
      >
        <svg width="30" height="30" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </a>
    </>
  );
}
